
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2xpE0", function(module, exports) {

$parcel$export(module.exports, "PageLayout", () => $1efdfe59c5e09a1a$export$6d1402fb58384e4f);
/* eslint-disable react/no-danger */ /* eslint-disable react/no-children-prop */ 
var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $lhCUr = parcelRequire("lhCUr");

var $ipPpS = parcelRequire("ipPpS");

var $g90Ph = parcelRequire("g90Ph");
var $hMSe7 = parcelRequire("hMSe7");
var $8hj5W = parcelRequire("8hj5W");
var $iuHMI = parcelRequire("iuHMI");
var $je0s0 = parcelRequire("je0s0");
var $laDNV = parcelRequire("laDNV");

var $6cnUO = parcelRequire("6cnUO");

var $inPa6 = parcelRequire("inPa6");

var $hnvzE = parcelRequire("hnvzE");

var $58PBI = parcelRequire("58PBI");

var $dIouf = parcelRequire("dIouf");

var $kVysQ = parcelRequire("kVysQ");
var $6CEg5 = parcelRequire("6CEg5");

var $i5Ioa = parcelRequire("i5Ioa");

var $7xVCs = parcelRequire("7xVCs");

var $1w55j = parcelRequire("1w55j");

var $l4CMG = parcelRequire("l4CMG");

var $5XPyz = parcelRequire("5XPyz");
parcelRequire("3PXtn");
var $hrAmX = parcelRequire("hrAmX");

var $3hLsK = parcelRequire("3hLsK");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $52id1 = parcelRequire("52id1");
var $6zNhq = parcelRequire("6zNhq");

var $azYNm = parcelRequire("azYNm");

var $1NBp8 = parcelRequire("1NBp8");

var $7zgzO = parcelRequire("7zgzO");

var $hZpML = parcelRequire("hZpML");

var $de2j9 = parcelRequire("de2j9");

var $1C7kY = parcelRequire("1C7kY");

var $iCTcO = parcelRequire("iCTcO");

var $9wGTI = parcelRequire("9wGTI");

var $gsf3i = parcelRequire("gsf3i");

var $cJWhP = parcelRequire("cJWhP");

var $eJTjU = parcelRequire("eJTjU");

var $kmLIp = parcelRequire("kmLIp");

var $lPNJr = parcelRequire("lPNJr");

var $hayzU = parcelRequire("hayzU");

var $1qDZ3 = parcelRequire("1qDZ3");

var $i6tGf = parcelRequire("i6tGf");

var $JUk5P = parcelRequire("JUk5P");
const $1efdfe59c5e09a1a$var$resize = ()=>{
    window.dispatchEvent(new Event('resize'));
};
const $1efdfe59c5e09a1a$var$isRoute = (pathname, route)=>Boolean(route.match(pathname || ''));
const $1efdfe59c5e09a1a$var$routesToShowPageLayoutBreadcrumbNav = [
    (0, $1NBp8.SPACE_ANALYTICS),
    (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST),
    (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE),
    (0, $1NBp8.SPACE_PAGES),
    (0, $1NBp8.SPACE_CALENDARS),
    (0, $1NBp8.DATABASE_CUSTOM_OVERVIEW),
    (0, $1NBp8.SPACE_QUESTIONS)
];
const $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT = 56;
const $1efdfe59c5e09a1a$export$6d1402fb58384e4f = /*#__PURE__*/ (0, $gwFzn.memo)(({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayout-outer'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1efdfe59c5e09a1a$var$PageLayoutInner, {
        children: children,
        view: view,
        standalone: standalone,
        isSpaceSettingsScreen: isSpaceSettingsScreen,
        editorPreloader: editorPreloader
    }));
});
const $1efdfe59c5e09a1a$var$PageLayoutInner = ({ children: children, view: view, standalone: standalone, isSpaceSettingsScreen: isSpaceSettingsScreen, editorPreloader: editorPreloader })=>{
    const [isInProductHelpOn, setIsInProductHelpOn] = (0, $gwFzn.useState)(false);
    const toggleInProductHelp = (val)=>{
        setIsInProductHelpOn(val);
    };
    const { scrollTree: scrollTree, pageTreeUpdater: pageTreeUpdater } = (0, $eJTjU.useScrollTree)({
        view: view
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireSidebarToggleAnalytics = (0, $gwFzn.useCallback)((action)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'spaceNavigation',
                source: 'containerNavigation',
                attributes: {
                    isOnEditRoute: isOnEditRoute
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isOnEditRoute
    ]);
    const onExpand = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'expanded');
        scrollTree();
        $1efdfe59c5e09a1a$var$resize();
        fireSidebarToggleAnalytics('expanded');
    }, [
        scrollTree,
        fireSidebarToggleAnalytics
    ]);
    const onCollapse = (0, $gwFzn.useCallback)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED, 'collapsed');
        $1efdfe59c5e09a1a$var$resize();
        fireSidebarToggleAnalytics('collapsed');
    }, [
        fireSidebarToggleAnalytics
    ]);
    const { isLoading: isLoading, isError: isError, isPanelOpen: isPanelOpen, isDismissed: isDismissed, openComponentId: openComponentId } = (0, $6zNhq.useQuickstartState)();
    const { isQuickstartEligible: isQuickstartEligible } = (0, $52id1.useQuickstartEligible)();
    const jswSpotlightOpen = openComponentId === (0, $3hLsK.SHOW_SWITCHER_SPOTLIGHT_ONLY) || openComponentId === (0, $3hLsK.JSW_XFLOW_SWITCHER_TOUR_TASK);
    // By default, the blanket should not be tinted, only tinted if onboarding jsw switcher spotlights are active
    const spotlightTriggeredByJswQS = isPanelOpen && !isDismissed && jswSpotlightOpen;
    const isQuickStartOpen = isPanelOpen && !isDismissed && !isLoading && !isError && isQuickstartEligible();
    const intl = (0, $dBxQj.default)();
    const { location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    // show breadcrumb nav for routes listed in routesToShowPageLayoutBreadcrumbNav
    const showBreadcrumbNavHeader = $1efdfe59c5e09a1a$var$routesToShowPageLayoutBreadcrumbNav.some((route)=>$1efdfe59c5e09a1a$var$isRoute(location?.pathname, route));
    const SideNavSkiplinkText = intl.formatMessage((0, $kmLIp.i18n).SideNav);
    const EditContentButtonPreloaderContextValue = (0, $gwFzn.useMemo)(()=>editorPreloader || (()=>{}), [
        editorPreloader
    ]);
    const [{ isSpaceGettingStartedTourInProgress: isSpaceGettingStartedTourInProgress }] = (0, $l4CMG.useSpaceGettingStartedTour)();
    const isRedactionsTourActive = (0, $gsf3i.useRedactionsTourIsActive)();
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const standaloneGlobalStyles = (bannerHeight)=>standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles-SSR",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.StyleFixSSRContentForNewLayoutWithRightSidebar)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                bannerHeight + $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix)
            ]
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lhCUr.Global), {
            "data-testid": "global-styles",
            styles: [
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleCodeBlockFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.fontFamilyCLSFix),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.styleNoPrintNav),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $lPNJr.moreActionDropdownCLSFix)
            ]
        });
    const standaloneGlobalStylesCompiled = (bannerHeight)=>standalone ? /*
   * We're injecting global styles to handle styling targets that are not part of the React app, but are children of the HTML body
   * Previously, this used to be a `<Global styles={[…]} />` from Emotion
   * But in the Compiled migration, there is no alternative and feels like the best path forward for now.
   */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.fixSSRContentForNewLayoutWithRightSidebarStyles)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", null, `[${(0, $lPNJr.SSR_LAYOUT_DATA_ATTR)}], [${(0, $lPNJr.SSR_IFRAME_ATTR)}] {
					top: ${bannerHeight + $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT + 2}px !important;
				}`)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            type: "text/css",
            dangerouslySetInnerHTML: {
                __html: (0, $lPNJr.globalStylesCompiled)
            }
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE,
        attributes: {
            errorBoundaryId: 'PageLayoutInner'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cJWhP.NavigationExperienceWrapper), {
        view: view,
        navVersion: "3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
        subjectId: "NavigationLoading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $58PBI.EditContentButtonPreloaderContext).Provider, {
        value: EditContentButtonPreloaderContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = bannerState.getTotalHeight(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
            blanketIsTinted: isSpaceGettingStartedTourInProgress || spotlightTriggeredByJswQS || isRedactionsTourActive
        }, (0, $9wGTI.fg)('confluence_frontend_page_layout_compiled') ? standaloneGlobalStylesCompiled(bannerHeight) : standaloneGlobalStyles(bannerHeight), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qDZ3.PageLayoutContextProviderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iuHMI.default), {
            onLeftSidebarExpand: onExpand,
            onLeftSidebarCollapse: onCollapse,
            skipLinksLabel: intl.formatMessage((0, $kmLIp.i18n).SkipLinks)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ZIndexWrapper), {
            zIndex: 14,
            showQuickStart: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g90Ph.default), {
            height: bannerHeight,
            isFixed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5XPyz.BannerContainer), null)), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "top-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $laDNV.default), {
            testId: "grid-topNav",
            skipLinkTitle: intl.formatMessage((0, $kmLIp.i18n).TopNav),
            id: "AkTopNav",
            height: $1efdfe59c5e09a1a$var$TOP_NAV_HEIGHT,
            isFixed: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1w55j.AppNavigationBase), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hayzU.LazyImpersonationFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i5Ioa.ProgressBar), {
            isNav4: false
        }))), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_TOP_NAV}.end`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMSe7.default), null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
            name: "side-nav"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $JUk5P.SideNavigationSwitcher), {
            view: view,
            skiplinkText: SideNavSkiplinkText,
            isSpaceSettingsScreen: isSpaceSettingsScreen
        })), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SIDE_NAV}.end`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.LayoutMainWrapper), {
            id: "layout-main-wrapper",
            showBreadcrumbNavHeader: showBreadcrumbNavHeader
        }, showBreadcrumbNavHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $azYNm.FixedBreadcrumbsNavForPageLayoutLoader), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8hj5W.default), {
            testId: "grid-main-container",
            id: "AkMainContent",
            skipLinkTitle: intl.formatMessage((0, $kmLIp.i18n).Main)
        }, children && !standalone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
            attribution: (0, $dIouf.Attribution).DISCO
        }, children) : null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_MAIN}.end`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i6tGf.RightSidebarLoader), {
            toggleInProductHelp: toggleInProductHelp
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ZIndexWrapper), {
            zIndex: 10,
            showQuickStart: isQuickStartOpen && !isInProductHelpOn
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $je0s0.default), {
            width: isQuickStartOpen ? 368 : 0,
            isFixed: isQuickStartOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lPNJr.ContentRightSidePanel), {
            id: "content-right-side-panel"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdatesContainer)=>{
            pageTreeUpdater.current = pageTreeStateUpdatesContainer;
            return null;
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iCTcO.PreviewPanelContainer), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1C7kY.GlobalComponentsLoader), null)));
    }))));
};

});
parcelRegister("g90Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $80fc6dd3168dbcc6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");

var $gXiBW = parcelRequire("gXiBW");
const $80fc6dd3168dbcc6$var$bannerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $i72d6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.BANNER)
});
const $80fc6dd3168dbcc6$var$bannerFixedStyles = (0, $3jLHL.css)({
    position: 'fixed',
    zIndex: 2,
    insetBlockStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $i72d6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $i72d6.LEFT_PANEL_WIDTH)
});
/**
 * __Banner__
 *
 * Provides a slot for a Banner within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $80fc6dd3168dbcc6$var$Banner = (props)=>{
    const { children: children, height: height = (0, $i72d6.DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
    const bannerHeight = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_BANNER_HEIGHT), height, shouldPersistHeight);
    (0, $gwFzn.useEffect)(()=>{
        (0, $fS0n4.default)({
            [(0, $i72d6.VAR_BANNER_HEIGHT)]: bannerHeight
        });
        return ()=>{
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_BANNER_HEIGHT)]: 0
            });
        };
    }, [
        bannerHeight
    ]);
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                $80fc6dd3168dbcc6$var$bannerStyles,
                isFixed && $80fc6dd3168dbcc6$var$bannerFixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('banner')
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
            variableName: (0, $i72d6.VAR_BANNER_HEIGHT),
            value: bannerHeight
        }), children));
};
var $80fc6dd3168dbcc6$export$2e2bcd8739ae039 = $80fc6dd3168dbcc6$var$Banner;

});

parcelRegister("hMSe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d5b5ecb1bfdf82a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");
const $0d5b5ecb1bfdf82a$var$contentStyles = (0, $3jLHL.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $0d5b5ecb1bfdf82a$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-testid": testId,
        css: $0d5b5ecb1bfdf82a$var$contentStyles
    }, children);
};
var $0d5b5ecb1bfdf82a$export$2e2bcd8739ae039 = $0d5b5ecb1bfdf82a$var$Content;

});

parcelRegister("8hj5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22fb3f3aa926f73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $7hpmn = parcelRequire("7hpmn");

var $ig6yX = parcelRequire("ig6yX");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c22fb3f3aa926f73$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $c22fb3f3aa926f73$var$mainStyles = (0, $3jLHL.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
const $c22fb3f3aa926f73$var$draggingStyles = (0, $3jLHL.css)({
    // Make sure drag to resize remains snappy.
    transition: 'none'
});
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $c22fb3f3aa926f73$var$flyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $c22fb3f3aa926f73$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $gL4SZ.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("main", {
            "data-testid": testId,
            css: [
                $c22fb3f3aa926f73$var$mainStyles,
                isDragging && $c22fb3f3aa926f73$var$draggingStyles,
                isFlyoutOpen && !isFixed && $c22fb3f3aa926f73$var$flyoutStyles,
                $c22fb3f3aa926f73$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('main')
        }, children));
};
var $c22fb3f3aa926f73$export$2e2bcd8739ae039 = $c22fb3f3aa926f73$var$Main;

});
parcelRegister("gL4SZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $79ba5697cb6a71da$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");
const $79ba5697cb6a71da$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $79ba5697cb6a71da$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $gwFzn.useState)($79ba5697cb6a71da$var$getIsDragging);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($79ba5697cb6a71da$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $i72d6.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $79ba5697cb6a71da$export$2e2bcd8739ae039 = $79ba5697cb6a71da$var$useIsSidebarDragging;

});

parcelRegister("jZM59", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeContext", () => $e6220385bdb59eee$export$aa5a712eea4c2ae8);
$parcel$export(module.exports, "usePageLayoutResize", () => $e6220385bdb59eee$export$10c7104037a7af62);
$parcel$export(module.exports, "useLeftSidebarFlyoutLock", () => $e6220385bdb59eee$export$94561f6055639ef7);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $gwFzn.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $gwFzn.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};

});


parcelRegister("iuHMI", function(module, exports) {

$parcel$export(module.exports, "default", () => $72942e2c49dd78cd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gYbmQ = parcelRequire("gYbmQ");
var $8179W = parcelRequire("8179W");

var $zwOCD = parcelRequire("zwOCD");
const $72942e2c49dd78cd$var$pageLayoutSelector = {
    [(0, $i72d6.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $72942e2c49dd78cd$var$gridTemplateAreasMobile = `
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.BANNER)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.TOP_NAVIGATION)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.CONTENT)}"
 `;
const $72942e2c49dd78cd$var$gridTemplateAreas = `
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.BANNER)} ${(0, $i72d6.RIGHT_PANEL)}"
  ${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.TOP_NAVIGATION)} ${(0, $i72d6.RIGHT_PANEL)}"
${''}
  "${(0, $i72d6.LEFT_PANEL)} ${(0, $i72d6.CONTENT)} ${(0, $i72d6.RIGHT_PANEL)}"
 `;
const $72942e2c49dd78cd$var$gridStyles = (0, $3jLHL.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $72942e2c49dd78cd$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $i72d6.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $i72d6.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $i72d6.BANNER_HEIGHT)} ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $72942e2c49dd78cd$var$gridStylesMobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $72942e2c49dd78cd$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $i72d6.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $72942e2c49dd78cd$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $i72d6.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $8179W.SkipLinksController), null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $zwOCD.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...$72942e2c49dd78cd$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $72942e2c49dd78cd$var$gridStyles,
            $72942e2c49dd78cd$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gYbmQ.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $72942e2c49dd78cd$export$2e2bcd8739ae039 = $72942e2c49dd78cd$var$PageLayout;

});
parcelRegister("gYbmQ", function(module, exports) {

$parcel$export(module.exports, "SidebarResizeController", () => $921ef14c0b0dd899$export$850bd1bba41f1448);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $ee7An = parcelRequire("ee7An");

var $7hpmn = parcelRequire("7hpmn");

var $fFc6D = parcelRequire("fFc6D");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");
const $921ef14c0b0dd899$var$handleDataAttributesAndCb = (callback = (0, $ee7An.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $921ef14c0b0dd899$var$leftSidebarSelector = (0, $nP1jF.getPageLayoutSlotCSSSelector)('left-sidebar');
const $921ef14c0b0dd899$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $gwFzn.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $gwFzn.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $gwFzn.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $gwFzn.useRef)(null);
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $gwFzn.useCallback)(()=>{
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery?.matches) {
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            transition.current?.complete();
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        transition.current?.action === 'expand') return;
        // flush existing transition
        transition.current?.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($921ef14c0b0dd899$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $7hpmn.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $d8F95.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $gwFzn.useCallback)((event, collapseWithoutTransition)=>{
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery?.matches) {
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            transition.current?.complete();
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        transition.current?.action === 'collapse') return;
        // flush existing transition
        transition.current?.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $921ef14c0b0dd899$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($921ef14c0b0dd899$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $7hpmn.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $d8F95.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
	 * Conditionally toggle the expanding or collapsing the sidebars.
	 * This supports our mobile flyout mode as well.
	 */ const toggleLeftSidebar = (0, $gwFzn.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $gwFzn.useEffect)(function mount() {
        return function unmount() {
            transition.current?.abort();
        };
    }, []);
    const context = (0, $gwFzn.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jZM59.SidebarResizeContext).Provider, {
        value: context,
        children: children
    });
};

});
parcelRegister("fFc6D", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $1487a997836a60f3$export$49e55ae2c03d6045);

var $gwFzn = parcelRequire("gwFzn");

var $d8F95 = parcelRequire("d8F95");

var $bNwbD = parcelRequire("bNwbD");

var $bWLcG = parcelRequire("bWLcG");
const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $gwFzn.useRef)(listener);
    (0, $gwFzn.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $d8F95.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("bNwbD", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $95c4b21f9fd4bea1$export$e5c5a5f917a5871c);

var $gwFzn = parcelRequire("gwFzn");
const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $gwFzn.useEffect) : (0, $gwFzn.useLayoutEffect);

});



parcelRegister("8179W", function(module, exports) {

$parcel$export(module.exports, "SkipLinksController", () => $f89eafe267ae0a24$export$da7be99d6a868f3d);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");

var $1HIA2 = parcelRequire("1HIA2");
const $f89eafe267ae0a24$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $i72d6.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
	 * If they are tied it is because one (or both) is
	 * a custom skiplink with a set index.
	 *
	 * Give the custom skiplink priority.
	 */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $f89eafe267ae0a24$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $gwFzn.useState)([]);
    const registerSkipLink = (0, $gwFzn.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($f89eafe267ae0a24$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $gwFzn.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1HIA2.SkipLinksContext).Provider, {
        value: context,
        children: children
    });
};

});

parcelRegister("zwOCD", function(module, exports) {

$parcel$export(module.exports, "SkipLinkWrapper", () => $736ed2e169d6421e$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $2Nwuj = parcelRequire("2Nwuj");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");

var $1HIA2 = parcelRequire("1HIA2");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $736ed2e169d6421e$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $736ed2e169d6421e$var$skipLinkStyles = (0, $3jLHL.css)({
    margin: "var(--ds-space-250, 10px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    background: "var(--ds-surface-overlay, white)",
    border: 'none',
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $6fnsQ.N30A)}, 0 2px 10px ${(0, $6fnsQ.N30A)}, 0 0 20px -4px ${(0, $6fnsQ.N60A)}`})`,
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $ig6yX.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $736ed2e169d6421e$var$skipLinkHeadingStyles = (0, $3jLHL.css)({
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $736ed2e169d6421e$var$skipLinkListStyles = (0, $3jLHL.css)({
    listStylePosition: 'outside',
    listStyleType: 'none',
    marginBlockStart: "var(--ds-space-050, 4px)",
    paddingInlineStart: 0
});
const $736ed2e169d6421e$var$skipLinkListItemStyles = (0, $3jLHL.css)({
    marginBlockStart: 0
});
const $736ed2e169d6421e$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $736ed2e169d6421e$var$assignIndex(num + 1, arr);
};
const $736ed2e169d6421e$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $1HIA2.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
            const listIndex = $736ed2e169d6421e$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $i72d6.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
    const label = skipLinksLabel || (0, $i72d6.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $736ed2e169d6421e$var$skipLinkStyles,
            $736ed2e169d6421e$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $3jLHL.jsx)("p", {
        css: $736ed2e169d6421e$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $3jLHL.jsx)("ol", {
        css: $736ed2e169d6421e$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $3jLHL.jsx)($736ed2e169d6421e$export$ef95c37428582a65, {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle)))));
};
const $736ed2e169d6421e$var$handleBlur = (event)=>{
    // @ts-ignore
    event.target.removeAttribute('tabindex');
    // @ts-ignore
    event.target.removeEventListener('blur', $736ed2e169d6421e$var$handleBlur);
};
const $736ed2e169d6421e$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', $736ed2e169d6421e$var$handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $736ed2e169d6421e$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)("li", {
        css: $736ed2e169d6421e$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $2Nwuj.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $736ed2e169d6421e$var$focusTargetRef(href)
    }, children));
};

});


parcelRegister("laDNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $29b537b6d819b3ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $1HIA2 = parcelRequire("1HIA2");

var $3xCvY = parcelRequire("3xCvY");

var $gXiBW = parcelRequire("gXiBW");
const $29b537b6d819b3ce$var$topNavigationStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $i72d6.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $i72d6.TOP_NAVIGATION)
});
const $29b537b6d819b3ce$var$fixedStyles = (0, $3jLHL.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $i72d6.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $i72d6.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $i72d6.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $29b537b6d819b3ce$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $i72d6.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $gwFzn.useEffect)(()=>{
        (0, $fS0n4.default)({
            [(0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), null, ({ className: className })=>/*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                $29b537b6d819b3ce$var$topNavigationStyles,
                isFixed && $29b537b6d819b3ce$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $nP1jF.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
            variableName: (0, $i72d6.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $29b537b6d819b3ce$export$2e2bcd8739ae039 = $29b537b6d819b3ce$var$TopNavigation;

});

parcelRegister("58PBI", function(module, exports) {

$parcel$export(module.exports, "EditContentButtonPreloaderContext", () => $037500d910957a1c$export$2dc50c54ef05578f);

var $gwFzn = parcelRequire("gwFzn");
const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';

});

parcelRegister("kVysQ", function(module, exports) {

$parcel$export(module.exports, "PERFORMANCE_SUBJECT_linkToPage", () => $35b50a968705ed01$export$c4d483efe8eba686);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_mainLayout", () => $35b50a968705ed01$export$1de09ba64e7728f2);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_manageWatcherDialog", () => $35b50a968705ed01$export$586856ecee8f0723);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigation", () => $35b50a968705ed01$export$51f018e0f9f84a74);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationFMP", () => $35b50a968705ed01$export$94afb8303c61d07d);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_sideNavigationFMP", () => $35b50a968705ed01$export$fe596581250cd9fc);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_navigationView", () => $35b50a968705ed01$export$88c949ed1e388f68);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_recentDropdown", () => $35b50a968705ed01$export$1a3cc5086fadf289);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog", () => $35b50a968705ed01$export$b35db70015797a33);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_copyPageTree", () => $35b50a968705ed01$export$5c78998b70cdff69);
$parcel$export(module.exports, "PERFORMANCE_SUBJECT_spaceDirectory", () => $35b50a968705ed01$export$1167e4f56227df4c);
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';

});

parcelRegister("6CEg5", function(module, exports) {

$parcel$export(module.exports, "PerformanceStart", () => $dc6daeb5b2d3b455$export$616e8efc277d5c6);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $9eE57 = parcelRequire("9eE57");
class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $gwFzn.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};

});

parcelRegister("i5Ioa", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $2a2fcb666bddc8b3$export$c17561cb55d4db30);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $9wGTI = parcelRequire("9wGTI");

var $kmyZQ = parcelRequire("kmyZQ");

var $2TpIg = parcelRequire("2TpIg");
const $2a2fcb666bddc8b3$export$c17561cb55d4db30 = /*#__PURE__*/ (0, $gwFzn.memo)(({ theme: theme, isNav4: isNav4 })=>{
    if ((0, $9wGTI.fg)('confluence_hide_loading_bar_all_types')) return null;
    const highlightColor = theme && theme.mode.productHome.backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $kmyZQ.ProgressBarContainer)
        ]
    }, (progressBar)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2TpIg.WrappedProgressBar), {
            highlightColor: highlightColor,
            status: progressBar.getStatus(),
            progressBar: progressBar,
            duration: progressBar.getDuration(),
            isNav4: isNav4
        }));
});

});
parcelRegister("2TpIg", function(module, exports) {

$parcel$export(module.exports, "WrappedProgressBar", () => $c75afe39495ae8f4$export$fa6e04c8cb414d0e);
/* WrappedProgressBar.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint react/no-danger: 0 */ /* eslint @atlaskit/ui-styling-standard/no-global-styles: 0 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $1ps47 = parcelRequire("1ps47");

var $ec2MS = parcelRequire("ec2MS");

var $76b2E = parcelRequire("76b2E");
const $c75afe39495ae8f4$var$newStyledProgressBarStyles = null;
const $c75afe39495ae8f4$var$ssrAnimation = null;
const $c75afe39495ae8f4$var$shimmerAnimation = null;
const $c75afe39495ae8f4$var$animationRules = {
    ssrOnly: "_y44va4o2",
    ssrAndDelayed: "_y44vvw8g",
    delayed: "_y44v16yq"
};
const $c75afe39495ae8f4$var$getStyledAttributes = (status, duration, ssrProgressBarDuration, ssrProgressBarLoadPercent)=>{
    switch(status){
        case 'START':
            return {
                transform: 'scaleX(0.99)',
                transitionDuration: `${duration}ms`
            };
        case 'FINISH':
            return {
                transform: 'scaleX(1)',
                transitionDuration: `${0, $1ps47.EXIT_ANIMATION_SPEED}ms`
            };
        case 'DELAYED':
            return {
                animation: 'shimmer 1200ms infinite',
                isDelayed: true,
                transform: 'scaleX(1)',
                transitionDuration: '0ms'
            };
        case 'SSR':
            // When browser is rendering the static HTML progress from 0 to 1/3
            // Then when SPA loads proceed from 33.33% to 99%, then 100% when apdex ends
            return {
                // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                animation: 'none',
                transform: `scaleX(${ssrProgressBarLoadPercent / 100})`,
                transitionDuration: '0ms'
            };
        case 'RESET':
        default:
            return {
                animation: 'none',
                transform: `scaleX(0)`,
                transitionDuration: '0ms'
            };
    }
};
const $c75afe39495ae8f4$var$StyledProgressBar = ({ isDelayed: isDelayed, background: background, style: style })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        style: {
            background: background,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style
        },
        "data-vc": "global-progress-bar-nav3",
        "data-testid": (0, $1ps47.PROGRESS_BAR_ID),
        className: (0, $35pXk.default)([
            "_4t3iyh40 _tzy41ck0 _kqswstnw _8hrz1nty _1bsb1osq _m6k41e03 _1pby18h8",
            isDelayed && true && $c75afe39495ae8f4$var$animationRules['delayed'],
            !isDelayed && undefined,
            isDelayed && undefined
        ])
    });
}; //start Nav 4 styles
const $c75afe39495ae8f4$var$generateLoadingBarStyles = ({ animation: animation = 'none', background: background, isDelayed: isDelayed, transform: transform, isNav4: isNav4, transitionDuration: transitionDuration })=>{
    return `
	body::before{
    content: '';
    display: block;
    animation: ${animation};
	  background: ${// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background};
    height: 2px;
    z-index: 999;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
	transform: ${transform};
	transition-duration: ${transitionDuration};
    transform-origin: 0 0;
    will-change: transform;
  }
  ${''}
	${isDelayed ? ` @keyframes shimmer { from { left: -15%; width: 15%; } to { left: 115%; width: 15%; } }` : ''}
	${isNav4 ? `opacity: '0.6',
	position: 'absolute',
	transformOrigin: '0 0',
	width: '100%',
	willChange: 'transform'` : ''}
	${// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    isNav4 && isDelayed && true ? `@keyframes shimmer {
			from: { left: '-15%', width: '15%' },
			to: { left: '115%', width: '15%' }
		}` : ''}
	${''}
	${''}
`;
};
const $c75afe39495ae8f4$export$fa6e04c8cb414d0e = ({ highlightColor: highlightColor = (0, $1ps47.DEFAULT_LOADING_BAR_COLOR), status: status, duration: duration, progressBar: progressBar, isNav4: isNav4 })=>{
    const ssrAttributes = $c75afe39495ae8f4$var$getStyledAttributes('SSR', 0, 6000, // ssrProgressBarDuration
    80 // ssrProgressBarLoadPercent
    ); // Initially, set progress bar to 0%, this ensures that progress bar does not start with 99% on the first load
    const initialAttributes = $c75afe39495ae8f4$var$getStyledAttributes('RESET', duration, 6000, // ssrProgressBarDuration,
    80 // ssrProgressBarLoadPercent
    );
    const [attributes, setAttributes] = (0, $gwFzn.useState)(// If the page is currently rendering on the server-side or was rendered on server-side
    // We need to set the start point synchronously
    status === 'SSR' ? ssrAttributes : initialAttributes);
    (0, $ec2MS.useProgressBarController)(progressBar);
    (0, $76b2E.useProgressBarListenerController)(progressBar); /**
                                                  * this logic (useEffect -> setTimeout -> setState) is necessary to fix a
                                                  * rendering issue where the progress bar animation starts loading at 99%.
                                                  * this should be investigated more and solved in a future ticket.
                                                  */ 
    (0, $gwFzn.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setAttributes($c75afe39495ae8f4$var$getStyledAttributes(status, duration, 6000, // ssrProgressBarDuration,
            80 // ssrProgressBarLoadPercent
            ));
        }, 0);
        return ()=>clearTimeout(timeout);
    }, [
        duration,
        status
    ]);
    const dynamicLoadingStyles = $c75afe39495ae8f4$var$generateLoadingBarStyles({
        ...attributes,
        background: highlightColor
    });
    if ((0, $9wGTI.fg)('confluence_frontend_dynamic_nav3_progress_bar')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
        "data-testid": (0, $1ps47.PROGRESS_BAR_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        },
        "data-vc": attributes.isNav4 ? '' : 'global-progress-bar-nav3'
    });
    return isNav4 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("style", {
        "data-testId": (0, $1ps47.PROGRESS_STYLE_ID),
        dangerouslySetInnerHTML: {
            __html: dynamicLoadingStyles
        }
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c75afe39495ae8f4$var$StyledProgressBar, {
        isNav4: false,
        background: highlightColor,
        style: attributes
    });
};

});
parcelRegister("ec2MS", function(module, exports) {

$parcel$export(module.exports, "useProgressBarController", () => $953a05b2dab9a5d3$export$724ea2b284503598);

var $gwFzn = parcelRequire("gwFzn");

var $7zgzO = parcelRequire("7zgzO");

var $lSOAM = parcelRequire("lSOAM");

var $9wGTI = parcelRequire("9wGTI");

var $9sGCn = parcelRequire("9sGCn");

var $98zed = parcelRequire("98zed");
/**
 * "contentSlug" is changable due to url encode, content title contains special charactor, changed title, etc.
 * If "contentSlug" changed, URL will be redirected, but the page content won't rerender.
 * In this case, the progress bar should not show up.
 * To handle that, use "contentId" as screen's identity, instead of pathname.
 * Assuming if a URL contains "contentSlug" param, then it much contains "contentId" as well.
 * The above assumption is valid according to: next/packages/named-routes/src/index.ts
 *
 * Another circumstance that progress bar should not show up is, when blog post url changed from pattern VIEW_BLOG_DATE_LEGACY to VIEW_BLOG or conversely.
 */ function $953a05b2dab9a5d3$var$isPreviousPage(match, prevMatch) {
    if (match && match.params && match.name && prevMatch && prevMatch.params && prevMatch.name && (match.name === prevMatch.name || match.name.startsWith('VIEW_BLOG') && prevMatch.name.startsWith('VIEW_BLOG') && 'contentSlug' in match.params && 'contentSlug' in prevMatch.params || match.name === 'HOME' && prevMatch.name === 'WIKI')) return prevMatch.params.contentId === match.params.contentId;
    return false;
}
const $953a05b2dab9a5d3$export$724ea2b284503598 = (progressBar)=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    (0, $gwFzn.useEffect)(()=>{
        const shouldHideProgressBar = ()=>{
            const conditions = [
                ()=>{
                    // Hide the progress bar for all live pages.
                    if (!(0, $9wGTI.fg)('confluence_perceived_perf_hide_loading_bar')) return false;
                    // Check for SSR'd live page. If it is, hide the progress bar.
                    if (livePageSSRStatus?.isTypeKnown && livePageSSRStatus?.isLive) return true;
                    // Check for non-SSR'd live data from live pages fast loading. If it is, hide the progress bar.
                    const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(match?.params.contentId);
                    const isLivePage = subType === 'live' && isArchived === false;
                    return isLivePage && match?.name === 'VIEW_PAGE';
                }
            ];
            return conditions.some((condition)=>condition());
        };
        if (!$953a05b2dab9a5d3$var$isPreviousPage(match, progressBar.prevMatch)) {
            // These are special conditions where we hide the progress bar for perceived performance experiments.
            if (shouldHideProgressBar()) progressBar.reset();
            else if ((0, $lSOAM.isBMPageLoad)(match) && (0, $lSOAM.hasBMPageLoadStarted)()) progressBar.start();
            else progressBar.reset();
        }
        progressBar.prevMatch = match;
        return ()=>{
            progressBar.reset();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        match && match.pathname
    ]);
};

});
parcelRegister("lSOAM", function(module, exports) {

$parcel$export(module.exports, "isBMPageLoad", () => $2a47a9fc48674e91$export$9dede01b6f349441);
$parcel$export(module.exports, "hasBMPageLoadStarted", () => $2a47a9fc48674e91$export$cb339d0cd5cc821c);
$parcel$export(module.exports, "createPageLoadMetric", () => $2a47a9fc48674e91$export$c5aa7fcaede4a84d);
$parcel$export(module.exports, "createCustomMetric", () => $2a47a9fc48674e91$export$19ba7be4fcf34f3d);
$parcel$export(module.exports, "createInteractionMetric", () => $2a47a9fc48674e91$export$36d7a61d0660e29c);
$parcel$export(module.exports, "createPageSegmentLoadMetric", () => $2a47a9fc48674e91$export$34f706592a2f7442);
$parcel$export(module.exports, "createConcurrentCustomMetric", () => $2a47a9fc48674e91$export$9db2e0f538bb10fa);
/* eslint-disable no-restricted-syntax */ 
var $3kTfj = parcelRequire("3kTfj");
var $kyiqo = parcelRequire("kyiqo");

var $64KID = parcelRequire("64KID");

var $i3c1S = parcelRequire("i3c1S");
const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $3kTfj.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const { pageLoad: $2a47a9fc48674e91$export$c5aa7fcaede4a84d, custom: $2a47a9fc48674e91$export$19ba7be4fcf34f3d, interaction: $2a47a9fc48674e91$export$36d7a61d0660e29c, pageSegmentLoad: $2a47a9fc48674e91$export$34f706592a2f7442, concurrent: $2a47a9fc48674e91$var$concurrent } = (0, $kyiqo.metrics);
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;

});
parcelRegister("kyiqo", function(module, exports) {

$parcel$export(module.exports, "metrics", () => $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54);

var $bCz2F = parcelRequire("bCz2F");

var $bs5rD = parcelRequire("bs5rD");
const $64dffbb6f4d5c9a0$export$b0c5c2fac8144e54 = {
    pageLoad: $bs5rD.pageLoad,
    pageSegmentLoad: $bs5rD.pageSegmentLoad,
    interaction: $bs5rD.interaction,
    custom: $bs5rD.custom,
    concurrent: $bCz2F.concurrent
};

});
parcelRegister("bCz2F", function(module, exports) {

$parcel$export(module.exports, "concurrent", () => $bbc3e125622b0c90$export$370df09ecc3de059);

var $j4jXg = parcelRequire("j4jXg");

var $bs5rD = parcelRequire("bs5rD");
const $bbc3e125622b0c90$var$concurrentMetrics = {};
const $bbc3e125622b0c90$var$getKey = (config, type)=>`${type}--${config.key}`;
const $bbc3e125622b0c90$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $bbc3e125622b0c90$var$ensurePath = (config, type)=>{
    const key = $bbc3e125622b0c90$var$getKey(config, type);
    if (!(key in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[key] = {};
};
const $bbc3e125622b0c90$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $bbc3e125622b0c90$var$getKey(config, type);
    if (concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics && $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $bbc3e125622b0c90$var$concurrentMetrics)) $bbc3e125622b0c90$var$concurrentMetrics[concurrentKey] = {};
};
const $bbc3e125622b0c90$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $bbc3e125622b0c90$var$validateConfig(config);
    $bbc3e125622b0c90$var$ensurePath(config, type);
    const metricFromCache = $bbc3e125622b0c90$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $j4jXg.BMEventsType).INLINE_RESULT ? (0, $bs5rD.interaction) : (0, $bs5rD.custom);
    const metric = metricFactory(config);
    $bbc3e125622b0c90$var$concurrentMetrics[$bbc3e125622b0c90$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $bbc3e125622b0c90$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$bbc3e125622b0c90$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $j4jXg.BMEventsType).CUSTOM)
};

});
parcelRegister("bs5rD", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $d0aae4122f29b5ae$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $d0aae4122f29b5ae$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $d0aae4122f29b5ae$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $d0aae4122f29b5ae$export$4c00f665f0d4b443);

var $iuio5 = parcelRequire("iuio5");

var $boXf9 = parcelRequire("boXf9");

var $giQku = parcelRequire("giQku");

var $j4jXg = parcelRequire("j4jXg");
const $d0aae4122f29b5ae$export$791d520f7e8058a5 = (config)=>{
    return new (0, $boXf9.PageLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_LOAD
    });
};
const $d0aae4122f29b5ae$export$94114666844d5f66 = (config)=>{
    return new (0, $giQku.PageSegmentLoadMetric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $d0aae4122f29b5ae$export$92473e6020ad89b4 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).INLINE_RESULT
    });
};
const $d0aae4122f29b5ae$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $iuio5.Metric)({
        ...config,
        type: (0, $j4jXg.BMEventsType).CUSTOM
    });
};

});
parcelRegister("iuio5", function(module, exports) {

$parcel$export(module.exports, "Metric", () => $6456fd2c244bded5$export$efdd3e096bc27746);

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $4k3LC = parcelRequire("4k3LC");
class $6456fd2c244bded5$export$efdd3e096bc27746 extends (0, $4k3LC.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $lH7GJ.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $11Zqj.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("boXf9", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", () => $b4ce8d24635e776a$export$3c51073271a9eac3);

var $h6RR2 = parcelRequire("h6RR2");

var $7RgFv = parcelRequire("7RgFv");

var $lH7GJ = parcelRequire("lH7GJ");

var $11Zqj = parcelRequire("11Zqj");

var $j4jXg = parcelRequire("j4jXg");

var $3znwT = parcelRequire("3znwT");

var $69Zr8 = parcelRequire("69Zr8");

var $e9ZCR = parcelRequire("e9ZCR");
class $b4ce8d24635e776a$export$3c51073271a9eac3 extends (0, $3znwT.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $69Zr8.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $69Zr8.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $3znwT.BasePageLoadMetric).FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $69Zr8.pageLoadMetaMetric).markFMP(mark);
            } else (0, $69Zr8.pageLoadMetaMetric).markFMP(this.marks[(0, $3znwT.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $lH7GJ.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $11Zqj.submitter).queue(data);
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $69Zr8.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $69Zr8.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $11Zqj.submitter).config.configChunk;
        if (!configChunk?.[(0, $j4jXg.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $e9ZCR.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $11Zqj.submitter).queue(webVitalMetric.getData());
        (0, $7RgFv.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("e9ZCR", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", () => $fd3d2d441d340510$export$dc0d85d4d6503cd7);

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");
class $fd3d2d441d340510$export$dc0d85d4d6503cd7 extends (0, $4k3LC.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $j4jXg.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $4k3LC.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("giQku", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", () => $4f83d9bff0211700$export$24c8bfcd77494cc1);

var $h6RR2 = parcelRequire("h6RR2");

var $j4jXg = parcelRequire("j4jXg");

var $4k3LC = parcelRequire("4k3LC");

var $iuio5 = parcelRequire("iuio5");

var $69Zr8 = parcelRequire("69Zr8");
class $4f83d9bff0211700$export$24c8bfcd77494cc1 extends (0, $iuio5.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $69Zr8.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4f83d9bff0211700$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($4f83d9bff0211700$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $69Zr8.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $h6RR2.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $j4jXg.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $4k3LC.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $4k3LC.MetricState).STARTED) (0, $69Zr8.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$4f83d9bff0211700$export$24c8bfcd77494cc1.FMP = 'fmp';

});




parcelRegister("i3c1S", function(module, exports) {

$parcel$export(module.exports, "getWaterfallTimings", () => $82eb5b0eb983d5b4$export$9dbd6bda36500fa9);

var $hZpML = parcelRequire("hZpML");

var $3YpC9 = parcelRequire("3YpC9");

var $6VdZc = parcelRequire("6VdZc");
// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}

});
parcelRegister("3YpC9", function(module, exports) {

$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_START", () => $4dbe182ee19642b3$export$f59b3ea823fcdb3d);
$parcel$export(module.exports, "PAGE_SEGMENT_MARK_PREFIX_END", () => $4dbe182ee19642b3$export$a217b163593f51a);
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';

});



parcelRegister("98zed", function(module, exports) {

$parcel$export(module.exports, "useIsLivePageWithSSR", () => $91141199ce9a5735$export$899773b8bcad4fc7);

var $dPJCf = parcelRequire("dPJCf");

var $eNbbn = parcelRequire("eNbbn");
const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};

});


parcelRegister("76b2E", function(module, exports) {

$parcel$export(module.exports, "useProgressBarListenerController", () => $fb45058d7703419b$export$70df3474f6d5549);

var $gwFzn = parcelRequire("gwFzn");

var $ew3Dj = parcelRequire("ew3Dj");
const $fb45058d7703419b$export$70df3474f6d5549 = (progressBar)=>{
    const { start: start, finish: finish } = progressBar;
    const postMessageHandler = (0, $gwFzn.useCallback)((event)=>{
        if (event.data && event.data.eventType == (0, $ew3Dj.START_MESSAGE_TYPE)) start(event.data.startDuration, event.data.delayDuration);
        if (event.data && event.data.eventType == (0, $ew3Dj.FINISH_MESSAGE_TYPE)) finish();
    }, [
        start,
        finish
    ]);
    (0, $gwFzn.useEffect)(()=>{
        window.addEventListener('message', postMessageHandler);
        return ()=>{
            window.removeEventListener('message', postMessageHandler);
        };
    }, [
        postMessageHandler
    ]);
};

});
parcelRegister("ew3Dj", function(module, exports) {

$parcel$export(module.exports, "START_MESSAGE_TYPE", () => $d8f8f2e6d4b52281$export$2613057e8390a95c);
$parcel$export(module.exports, "FINISH_MESSAGE_TYPE", () => $d8f8f2e6d4b52281$export$87f9c116a4a9abb1);
const $d8f8f2e6d4b52281$export$2613057e8390a95c = 'start_progress_bar';
const $d8f8f2e6d4b52281$export$87f9c116a4a9abb1 = 'finish_progress_bar';

});




parcelRegister("7xVCs", function(module, exports) {

$parcel$export(module.exports, "PageTreeStateUpdater", () => $3c23582ca65aa05a$export$90a06df90d015db9);

var $atveb = parcelRequire("atveb");

var $ipPpS = parcelRequire("ipPpS");
class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $ipPpS.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($atveb)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}

});

parcelRegister("1w55j", function(module, exports) {

$parcel$export(module.exports, "AppNavigationBaseLoader", () => $4091cc7c98ecb0e6$export$b28750cb7fe7eee);
$parcel$export(module.exports, "AppNavigationBase", () => $4091cc7c98ecb0e6$export$22d0a9aee43f07d7);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $7d2Nc = parcelRequire("7d2Nc");

var $8w1c1 = parcelRequire("8w1c1");

var $34WJV = parcelRequire("34WJV");

const $4091cc7c98ecb0e6$export$b28750cb7fe7eee = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pQYq4",
    name: "AppNavigationBaseLoader",
    loader: async ()=>(await (parcelRequire("3CPsI"))).AppNavigation,
    loading: (0, $34WJV.NavSkeleton)
});
const $4091cc7c98ecb0e6$var$AppNavigationBaseComponent = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4091cc7c98ecb0e6$export$b28750cb7fe7eee, props));
const $4091cc7c98ecb0e6$export$22d0a9aee43f07d7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($4091cc7c98ecb0e6$var$AppNavigationBaseComponent);

});
parcelRegister("7d2Nc", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadStart", () => $c2bdb1677e0a2d6c$export$f11db193fdaffcc9);

var $gwFzn = parcelRequire("gwFzn");

var $3kTfj = parcelRequire("3kTfj");


var $dIouf = parcelRequire("dIouf");

var $N1nBh = parcelRequire("N1nBh");

var $3YpC9 = parcelRequire("3YpC9");
const $c2bdb1677e0a2d6c$var$noop = ()=>{};
const $c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $gwFzn.memo)(({ metric: metric, onComplete: onComplete = $c2bdb1677e0a2d6c$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY, isCustomStart: isCustomStart = false })=>{
    const handlePageLoadMetricStart = (0, $gwFzn.useCallback)(()=>{
        if (metric) {
            (0, $3kTfj.browserMetrics).getPageLoadMetric().mark(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${metric.key}`);
            if (isCustomStart) metric.start();
            else metric.startFromPageLoad();
            onComplete();
        }
    }, [
        metric,
        onComplete,
        isCustomStart
    ]);
    (0, $N1nBh.usePerformanceAction)(handlePageLoadMetricStart, timing);
    return null;
});
const $c2bdb1677e0a2d6c$export$f11db193fdaffcc9 = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).BACKBONE
})($c2bdb1677e0a2d6c$var$PageSegmentLoadStartComponent);

});
parcelRegister("N1nBh", function(module, exports) {

$parcel$export(module.exports, "ActionTiming", () => $4fef2d066feab689$export$6a673e74e98cdf55);
$parcel$export(module.exports, "usePerformanceAction", () => $4fef2d066feab689$export$454639fd58f598bd);

var $gwFzn = parcelRequire("gwFzn");
var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
	 * This will perform the given action at a scheduled time after the
	 * component has painted.
	 *
	 * This is the default behavior.
	 */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
	 * This will perform the given action at the next animation frame (after the
	 * component has been painted).
	 */ ActionTiming["PAINT"] = "PAINT";
    /**
	 * This will perform the given action at the moment its render function
	 * fires.
	 *
	 * NOTE: This is called _within_ the render body, making it unpure. The
	 * component is memoized, so it will fire this only once for a given set
	 * of props. Be careful when using this, since it is unsafe.
	 */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $gwFzn.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $gwFzn.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};

});


parcelRegister("8w1c1", function(module, exports) {

$parcel$export(module.exports, "APP_NAVIGATION_METRIC", () => $73e19354f9924125$export$d9a22aa9387ada7a);

var $lSOAM = parcelRequire("lSOAM");

var $jX1qB = parcelRequire("jX1qB");
const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});

});
parcelRegister("jX1qB", function(module, exports) {

$parcel$export(module.exports, "APP_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$9e40500efe28ac9e);
$parcel$export(module.exports, "BLOG_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$38b273cdbbf56c26);
$parcel$export(module.exports, "BYLINE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1ac23cd5807df863);
$parcel$export(module.exports, "READ_TIME_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$5bbb36bee09a5671);
$parcel$export(module.exports, "CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$a79607497a4a710c);
$parcel$export(module.exports, "CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c56a99673f1bb7bb);
$parcel$export(module.exports, "CONTENT_RENDERER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$140a493a9e781fe2);
$parcel$export(module.exports, "CONTENT_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1285ccb0399c01);
$parcel$export(module.exports, "FAVOURITE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$eb5bb54418693284);
$parcel$export(module.exports, "FOCUSED_INLINE_COMMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3fde425dbc74423b);
$parcel$export(module.exports, "INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6a58cce6529da40e);
$parcel$export(module.exports, "FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$8910bc840e3ee4ce);
$parcel$export(module.exports, "RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf572571ca036b67);
$parcel$export(module.exports, "EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$644778267d4a4a82);
$parcel$export(module.exports, "MEDIA_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7416ef7ed24ec47f);
$parcel$export(module.exports, "PAGE_COMMENTS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e4ff10a0a39a7217);
$parcel$export(module.exports, "PAGE_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$6648c9be174e6923);
$parcel$export(module.exports, "FEED_REACTIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d3d6144128aaee3);
$parcel$export(module.exports, "PAGE_TREE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499);
$parcel$export(module.exports, "RESTRICTIONS_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d1dfca9e0eb45581);
$parcel$export(module.exports, "GLOBAL_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$312db7b759bad970);
$parcel$export(module.exports, "SPACE_NAVIGATION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$cf2a6bf49e73b304);
$parcel$export(module.exports, "SPACE_APPS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$84f6b5717c3fb962);
$parcel$export(module.exports, "WATCH_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1a423f2548c46be3);
$parcel$export(module.exports, "HOME_OVERVIEW_RECENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6426c6941656619);
$parcel$export(module.exports, "HOME_OVERVIEW_FEED_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$14f30a91623dfcf3);
$parcel$export(module.exports, "HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$c6926beb57b60636);
$parcel$export(module.exports, "HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$687913e127f52cc3);
$parcel$export(module.exports, "HOME_RECENTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0);
$parcel$export(module.exports, "HOME_STARRED_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$76243e8aa4afaa0b);
$parcel$export(module.exports, "HOME_DRAFTS_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1df6f3f29083f48);
$parcel$export(module.exports, "END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7b32848c9413526a);
$parcel$export(module.exports, "IN_EDITOR_TEMPLATES_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$58fbb0ba50341103);
$parcel$export(module.exports, "NCS_CONNECTED_FMP_KEY", () => $fa0ea3428ec5aa62$export$4f481f063369df3c);
$parcel$export(module.exports, "ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$db1b9793e009e605);
$parcel$export(module.exports, "ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$90bda069d4bf981b);
$parcel$export(module.exports, "ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$f11e1d4269141c0e);
$parcel$export(module.exports, "DATABASE_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$f0298cbab4a44998);
$parcel$export(module.exports, "SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5);
$parcel$export(module.exports, "WHITEBOARD_HEADER_SEGMENT_METRIC_KEY", () => $fa0ea3428ec5aa62$export$cf2f52fec740bdea);
$parcel$export(module.exports, "OBJECT_HEADER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$52050233077a1838);
$parcel$export(module.exports, "CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$e1ab333f0b70b317);
$parcel$export(module.exports, "WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4);
$parcel$export(module.exports, "DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b95bd4bfc46932fc);
$parcel$export(module.exports, "SHARE_BUTTON_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$bf838b84ba2f7b95);
$parcel$export(module.exports, "VIEW_PAGE_LABELS_METRIC_KEY", () => $fa0ea3428ec5aa62$export$79910402df6be117);
$parcel$export(module.exports, "ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$d86af34f7dc194b4);
$parcel$export(module.exports, "CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb);
$parcel$export(module.exports, "SPACE_PERMISSIONS_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$1939caa7fae28ef5);
$parcel$export(module.exports, "VIEW_PAGE_CONTAINER_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3f06ee123a5ad183);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$37da6122cd60d332);
$parcel$export(module.exports, "EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$3437c1f145cfce19);
$parcel$export(module.exports, "EDITOR_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$7903037283afbce0);
$parcel$export(module.exports, "RECAP_MODAL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$fdd1a35fb559480a);
$parcel$export(module.exports, "OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$31d10d7597db11d3);
$parcel$export(module.exports, "COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$b64d520f9b37dcd7);
$parcel$export(module.exports, "COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$50553e47471a0f5e);
$parcel$export(module.exports, "COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY", () => $fa0ea3428ec5aa62$export$f2a6407ac901fd8d);
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$fdd1a35fb559480a = 'recap-modal';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';

});


parcelRegister("34WJV", function(module, exports) {

$parcel$export(module.exports, "NavSkeleton", () => $6036c1accea2b6a5$export$52352b3c9f328940);
/* NavSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $6036c1accea2b6a5$export$52352b3c9f328940 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bsb1osq _4t3i8vuz _bfhkn82g _16r2h3tw _aetrb3bt _18postnw _19doidpf _32rxidpf _15l21osq _1qdg1y44",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3CPsI", function(module, exports) {

let $2a3cd703f97b8e7f$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2a3cd703f97b8e7f$var$load("eI3Gm"),
    $2a3cd703f97b8e7f$var$load("bEnB5"),
    $2a3cd703f97b8e7f$var$load("3oc0Z"),
    $2a3cd703f97b8e7f$var$load("ho08C"),
    $2a3cd703f97b8e7f$var$load("i73Fi"),
    $2a3cd703f97b8e7f$var$load("4Bp5z"),
    $2a3cd703f97b8e7f$var$load("7VyeJ"),
    $2a3cd703f97b8e7f$var$load("feg87"),
    $2a3cd703f97b8e7f$var$load("fKO1l"),
    $2a3cd703f97b8e7f$var$load("6pdbo"),
    $2a3cd703f97b8e7f$var$load("cJdPE"),
    $2a3cd703f97b8e7f$var$load("bdLqi"),
    $2a3cd703f97b8e7f$var$load("cZgEZ"),
    $2a3cd703f97b8e7f$var$load("iAspJ"),
    $2a3cd703f97b8e7f$var$load("1epse"),
    $2a3cd703f97b8e7f$var$load("kjZZD"),
    $2a3cd703f97b8e7f$var$load("aZinD"),
    $2a3cd703f97b8e7f$var$load("c6MKV"),
    $2a3cd703f97b8e7f$var$load("8fTZe"),
    $2a3cd703f97b8e7f$var$load("6qah4"),
    $2a3cd703f97b8e7f$var$load("ffEVr"),
    $2a3cd703f97b8e7f$var$load("joJy8"),
    $2a3cd703f97b8e7f$var$load("aHE9G"),
    $2a3cd703f97b8e7f$var$load("i0gb6"),
    $2a3cd703f97b8e7f$var$load("g7QTt"),
    $2a3cd703f97b8e7f$var$load("jfTrX")
]).then(()=>parcelRequire('kA4n2'));

});


parcelRegister("3PXtn", function(module, exports) {

$parcel$export(module.exports, "BannerSpacer", () => $a5e2ea3da11107ff$export$6801ec5f8af8462d);
$parcel$export(module.exports, "BannerStateContainer", () => (parcelRequire("hrAmX")).BannerStateContainer);
$parcel$export(module.exports, "FloatingBannerStateContainer", () => (parcelRequire("1a6Dn")).FloatingBannerStateContainer);
$parcel$export(module.exports, "WithoutBanners", () => (parcelRequire("iSSAX")).WithoutBanners);
$parcel$export(module.exports, "BannerContext", () => (parcelRequire("jxpvN")).BannerContext);
$parcel$export(module.exports, "BannerContextProvider", () => (parcelRequire("6pwLK")).BannerContextProvider);

var $jmjWc = parcelRequire("jmjWc");

var $hrAmX = parcelRequire("hrAmX");

var $1a6Dn = parcelRequire("1a6Dn");

var $iSSAX = parcelRequire("iSSAX");

var $jxpvN = parcelRequire("jxpvN");

var $6pwLK = parcelRequire("6pwLK");

const $a5e2ea3da11107ff$export$6801ec5f8af8462d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "paSPC",
    name: "BannerSpacer",
    loader: async ()=>(await (parcelRequire("lP4x8"))).BannerSpacer
});

});
parcelRegister("hrAmX", function(module, exports) {

$parcel$export(module.exports, "findBanner", () => $6ee3834dea9f6c5c$export$f7df67e8f3ba0620);
$parcel$export(module.exports, "BannerStateContainer", () => $6ee3834dea9f6c5c$export$bbac707b3ebb5681);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");

var $1dnxO = parcelRequire("1dnxO");
const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $ipPpS.Container) {
    constructor(props = {}){
        super();
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        const navHeight = (0, $1dnxO.getIsNav4Enabled)() ? 48 : 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = props.initialState?.banners || [];
    }
}

});

parcelRegister("1a6Dn", function(module, exports) {

$parcel$export(module.exports, "FloatingBannerStateContainer", () => $d3905c2d386f370c$export$c59406a16f2704a5);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");

var $hrAmX = parcelRequire("hrAmX");
class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $ipPpS.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}

});

parcelRegister("iSSAX", function(module, exports) {

$parcel$export(module.exports, "WithoutBanners", () => $52160d3a5a95f095$export$b78d9b9240bb4db3);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $1a6Dn = parcelRequire("1a6Dn");

var $hrAmX = parcelRequire("hrAmX");
const $52160d3a5a95f095$export$b78d9b9240bb4db3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Provider), {
        inject: [
            new (0, $hrAmX.BannerStateContainer)({
                hasTopNav: false
            }),
            new (0, $1a6Dn.FloatingBannerStateContainer)()
        ]
    }, children));

});

parcelRegister("jxpvN", function(module, exports) {

$parcel$export(module.exports, "BannerContext", () => $205998aae8e9bd72$export$60bd66ed7962b851);

var $gwFzn = parcelRequire("gwFzn");
const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';

});

parcelRegister("6pwLK", function(module, exports) {

$parcel$export(module.exports, "BannerContextProvider", () => $f91eb48475fb1f4e$export$fce08d0d9d687787);

var $gwFzn = parcelRequire("gwFzn");

var $5vi32 = parcelRequire("5vi32");

var $jxpvN = parcelRequire("jxpvN");
const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue } = (0, $gwFzn.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence ? false : inheritedOrDefaultValue;
    const bannerContextValue = (0, $gwFzn.useMemo)(()=>({
            includeTopNav: includeTopNav
        }), [
        includeTopNav
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};

});
parcelRegister("5vi32", function(module, exports) {

$parcel$export(module.exports, "useIsEmbeddedConfluence_DO_NOT_USE", () => $36802f16e927d19b$export$c850f609dc850980);

var $gwFzn = parcelRequire("gwFzn");

var $1iSzD = parcelRequire("1iSzD");

var $7zgzO = parcelRequire("7zgzO");
function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}

});


parcelRegister("lP4x8", function(module, exports) {

let $fe31e0a8ccffa917$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $fe31e0a8ccffa917$var$load("9mi9f").then(()=>parcelRequire('HJnwX'));

});


parcelRegister("3hLsK", function(module, exports) {

$parcel$export(module.exports, "ORIGIN_ATTRIBUTES", () => $5b23a7bd3e23e56e$export$517f3026b656d37a);
$parcel$export(module.exports, "QUICKSTART_STATE_KEYS", () => $5b23a7bd3e23e56e$export$67d2bdeab932157d);
$parcel$export(module.exports, "INTEGRATION_TASK", () => $5b23a7bd3e23e56e$export$d05456a8ea0de639);
$parcel$export(module.exports, "JSW_XFLOW_SWITCHER_TOUR_TASK", () => $5b23a7bd3e23e56e$export$46c46696b5a7ae4f);
$parcel$export(module.exports, "JSW_CONFLUENCE_INTRO_TASK", () => $5b23a7bd3e23e56e$export$93034abc7a9a36e);
$parcel$export(module.exports, "JSW_CONFLUENCE_MODAL", () => $5b23a7bd3e23e56e$export$f72f5e831f728bdb);
$parcel$export(module.exports, "SHOW_SWITCHER_SPOTLIGHT_ONLY", () => $5b23a7bd3e23e56e$export$d9362ed0ac94a9f8);
$parcel$export(module.exports, "QSV2_INVITE_TEAMMATE_TASK", () => $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2);
$parcel$export(module.exports, "QSV2_CONFLUENCE_GUIDE_TASK", () => $5b23a7bd3e23e56e$export$bf35811a56a7cd87);
$parcel$export(module.exports, "QSV2_INTEGRATION_TASK", () => $5b23a7bd3e23e56e$export$417c74a93b7a4bc9);
$parcel$export(module.exports, "QSV2_SITE_TOUR_TASK", () => $5b23a7bd3e23e56e$export$2f37c8b16273f56e);
$parcel$export(module.exports, "QSV2_SPOTLIGHT", () => $5b23a7bd3e23e56e$export$e3400d8b82a2f6c1);
$parcel$export(module.exports, "MIGRATIONS_WELCOME_TASK", () => $5b23a7bd3e23e56e$export$cec5ff8d02753e42);
$parcel$export(module.exports, "MIGRATIONS_NEW_PAGE_TASK", () => $5b23a7bd3e23e56e$export$291c48af440cb477);
$parcel$export(module.exports, "MIGRATIONS_COLLABORATE_TASK", () => $5b23a7bd3e23e56e$export$af64633856549760);
$parcel$export(module.exports, "MIGRATIONS_FIND_AND_ORGANIZE_PAGES_TASK", () => $5b23a7bd3e23e56e$export$c85b665118ff388b);
$parcel$export(module.exports, "MIGRATIONS_EDIT_AND_CUSTOMIZE_CONTENT_TASK", () => $5b23a7bd3e23e56e$export$91579532952a6b5);
$parcel$export(module.exports, "NQSV2_HELP_TASK", () => $5b23a7bd3e23e56e$export$d9afba8e0525ce5f);
$parcel$export(module.exports, "NQSV2_CONFLUENCE_101_TASK", () => $5b23a7bd3e23e56e$export$2da9139b7da400a3);
$parcel$export(module.exports, "NQSV2_CREATE_TASK", () => $5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9);
$parcel$export(module.exports, "NQSV2_COLLABORATE_TASK", () => $5b23a7bd3e23e56e$export$96076d1ee44d366);
$parcel$export(module.exports, "TASK_ID_TO_STATE_KEY", () => $5b23a7bd3e23e56e$export$1f520c852194e989);
$parcel$export(module.exports, "IGNORE_COMPLETE_TASK_ON_TOGGLE", () => $5b23a7bd3e23e56e$export$2883f67b1bf0f40c);
const $5b23a7bd3e23e56e$export$517f3026b656d37a = 'onboarding-origin-state:attributes';
const $5b23a7bd3e23e56e$export$67d2bdeab932157d = {
    IS_PANEL_OPEN: 'quickstart-state:isPanelOpen',
    IS_DISMISSED: 'quickstart-state:isDismissed',
    OPEN_TASK_ID: 'quickstart-state:openTaskId',
    OPEN_COMPONENT_ID: 'quickstart-state:openComponentId',
    JSW_CONFLUENCE_INTRO_TASK: 'quickstart-state:jswConfIntroCompleted',
    HELP_COMPLETED: 'quickstart-state:helpCompleted',
    SPACE_MODAL_COMPLETED: 'quickstart-state:spaceModalCompleted',
    SPACE_TOUR_COMPLETED: 'quickstart-state:spaceTourCompleted',
    COLLABORATE_COMPLETED: 'quickstart-state:collaborateCompleted',
    HOME_MODAL_COMPLETED: 'quickstart-state:homeModalCompleted',
    HOME_TOUR_COMPLETED: 'quickstart-state:homeTourCompleted',
    MOBILE_COMPLETED: 'quickstart-state:mobileCompleted',
    HAS_SEEN_DISMISSED_FLAG: 'quickstart-state:hasSeenDismissedFlag',
    IS_MIGRATED_USER_V2: 'quickstart-state:isMigratedUserV2',
    JSW_XFLOW_SWITCHER_TOUR_TASK: 'quickstart-state:jswXflowSwitcherTourCompleted',
    ORIGIN_ATTRIBUTES: $5b23a7bd3e23e56e$export$517f3026b656d37a,
    JSW_CONFLUENCE_MODAL: 'quickstart-state:jswXFlowModalCompleted',
    EDITOR_TUTORIAL_TASK_COMPLETED: 'quickstart-state:editorTutorialTaskCompleted',
    QSV2_READ_GUIDE_COMPLETED: 'quickstart-state:qsv2ReadConfluenceGuideCompleted',
    QSV2_INVITE_TEAMMATE_TASK: 'quickstart-state:qsv2InviteTeammateCompleted',
    QSV2_INTEGRATION_TASK: 'quickstart-state:qsv2IntegrationCompleted',
    QSV2_VIDEO_TOUR_COMPLETED: 'quickstart-state:qsv2SiteVideoTourCompleted',
    QSV2_SPOTLIGHT_COMPLETED: 'quickstart-state:qsv2SpotlightCompleted',
    MIGRATIONS_WELCOME_TASK: 'quickstart-state:migrationsWelcomeCompleted',
    MIGRATIONS_NEW_PAGE_TASK: 'quickstart-state:migrationsNewPageCompleted',
    MIGRATIONS_COLLABORATE_TASK: 'quickstart-state:migrationsCollaborateCompleted',
    MIGRATIONS_FIND_AND_ORGANIZE_PAGES_COMPLETED: 'quickstart-state:migrationsFindAndOrganizePagesCompleted',
    MIGRATIONS_EDIT_AND_CUSTOMIZE_CONTENT_TASK: 'quickstart-state:migrationsEditAndCustomizeContentCompleted',
    SIMPLIFY_ADMIN_RENAME_TASK: 'quickstart-state:simplifyAdminRenameSiteCompleted',
    NQSV2_HELP_TASK_COMPLETED: 'quickstart-state:nqsv2HelpCompleted',
    NQSV2_CREATE_TASK_COMPLETED: 'quickstart-state:nqsv2CreateCompleted',
    NQSV2_COLLABORATE_TASK_COMPLETED: 'quickstart-state:nqsv2CollaborateCompleted',
    NQSV2_CONFLUENCE_101_TASK: 'quickstart-state:nqsv2Confluence101Completed'
};
const $5b23a7bd3e23e56e$export$69afb55780da55ef = 'quickstart-checklist.invite-teammate';
const $5b23a7bd3e23e56e$export$d05456a8ea0de639 = 'quickstart-checklist.integration';
const $5b23a7bd3e23e56e$export$46c46696b5a7ae4f = 'quickstart-checklist.jsw-xflow-switcher-tour';
const $5b23a7bd3e23e56e$export$93034abc7a9a36e = 'quickstart-checklist.jsw-conf-intro';
const $5b23a7bd3e23e56e$export$f72f5e831f728bdb = 'quickstart-checklist.jswXFlowModalCompleted';
const $5b23a7bd3e23e56e$export$d9362ed0ac94a9f8 = 'SHOW_SWITCHER_SPOTLIGHT_ONLY';
const $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2 = 'quickstart-checklist.invite-teammate-v2';
const $5b23a7bd3e23e56e$export$bf35811a56a7cd87 = 'quickstart-checklist.confluence-guide-v2';
const $5b23a7bd3e23e56e$export$417c74a93b7a4bc9 = 'quickstart-checklist.integration-v2';
const $5b23a7bd3e23e56e$export$2f37c8b16273f56e = 'quickstart-checklist.site-tour-v2';
const $5b23a7bd3e23e56e$export$e3400d8b82a2f6c1 = 'quickstart-checklist.close-spotlight';
const $5b23a7bd3e23e56e$export$cec5ff8d02753e42 = 'quickstart-checklist.migrations.welcome';
const $5b23a7bd3e23e56e$export$291c48af440cb477 = 'quickstart-checklist.migrations.new-page';
const $5b23a7bd3e23e56e$export$af64633856549760 = 'quickstart-checklist.migrations.collaborate';
const $5b23a7bd3e23e56e$export$c85b665118ff388b = 'quickstart-checklist.migrations.find-and-organize-pages';
const $5b23a7bd3e23e56e$export$91579532952a6b5 = 'quickstart-checklist.migrations.edit-and-customize-content';
const $5b23a7bd3e23e56e$export$d521d3f5ee5a7baa = 'quickstart-checklist.simplify.admin.rename-site';
const $5b23a7bd3e23e56e$export$d9afba8e0525ce5f = 'quickstart-checklist.nth-user-v2.help';
const $5b23a7bd3e23e56e$export$2da9139b7da400a3 = 'quickstart-checklist.nth-user-v2.confluence-101';
const $5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9 = 'quickstart-checklist.nth-user-v2.create';
const $5b23a7bd3e23e56e$export$96076d1ee44d366 = 'quickstart-checklist.nth-user-v2.collaborate';
const $5b23a7bd3e23e56e$export$1f520c852194e989 = {
    [$5b23a7bd3e23e56e$export$69afb55780da55ef]: 'inviteTeammateCompleted',
    [$5b23a7bd3e23e56e$export$d05456a8ea0de639]: 'integrationCompleted',
    [$5b23a7bd3e23e56e$export$46c46696b5a7ae4f]: 'jswXflowSwitcherTourCompleted',
    [$5b23a7bd3e23e56e$export$93034abc7a9a36e]: 'jswConfIntroCompleted',
    [$5b23a7bd3e23e56e$export$f72f5e831f728bdb]: 'jswXFlowModalCompleted',
    [$5b23a7bd3e23e56e$export$bf35811a56a7cd87]: 'qsv2ReadConfluenceGuideCompleted',
    [$5b23a7bd3e23e56e$export$6e0ac6a22e470ae2]: 'qsv2InviteTeammateCompleted',
    [$5b23a7bd3e23e56e$export$417c74a93b7a4bc9]: 'qsv2IntegrationCompleted',
    [$5b23a7bd3e23e56e$export$2f37c8b16273f56e]: 'qsv2SiteVideoTourCompleted',
    [$5b23a7bd3e23e56e$export$e3400d8b82a2f6c1]: 'qsv2SpotlightCompleted',
    [$5b23a7bd3e23e56e$export$cec5ff8d02753e42]: 'migrationsWelcomeCompleted',
    [$5b23a7bd3e23e56e$export$291c48af440cb477]: 'migrationsNewPageCompleted',
    [$5b23a7bd3e23e56e$export$af64633856549760]: 'migrationsCollaborateCompleted',
    [$5b23a7bd3e23e56e$export$c85b665118ff388b]: 'migrationsFindAndOrganizePagesCompleted',
    [$5b23a7bd3e23e56e$export$91579532952a6b5]: 'migrationsEditAndCustomizeContentCompleted',
    [$5b23a7bd3e23e56e$export$d521d3f5ee5a7baa]: 'simplifyAdminRenameSiteCompleted',
    [$5b23a7bd3e23e56e$export$7a6989d0bcfe7ca9]: 'nqsv2CreateCompleted',
    [$5b23a7bd3e23e56e$export$96076d1ee44d366]: 'nqsv2CollaborateCompleted',
    [$5b23a7bd3e23e56e$export$d9afba8e0525ce5f]: 'nqsv2HelpCompleted',
    [$5b23a7bd3e23e56e$export$2da9139b7da400a3]: 'nqsv2Confluence101Completed'
};
const $5b23a7bd3e23e56e$export$2883f67b1bf0f40c = new Set([
    $5b23a7bd3e23e56e$export$69afb55780da55ef,
    $5b23a7bd3e23e56e$export$93034abc7a9a36e,
    $5b23a7bd3e23e56e$export$bf35811a56a7cd87,
    $5b23a7bd3e23e56e$export$6e0ac6a22e470ae2,
    $5b23a7bd3e23e56e$export$417c74a93b7a4bc9,
    $5b23a7bd3e23e56e$export$2f37c8b16273f56e,
    $5b23a7bd3e23e56e$export$cec5ff8d02753e42,
    $5b23a7bd3e23e56e$export$291c48af440cb477,
    $5b23a7bd3e23e56e$export$af64633856549760,
    $5b23a7bd3e23e56e$export$91579532952a6b5,
    $5b23a7bd3e23e56e$export$c85b665118ff388b,
    $5b23a7bd3e23e56e$export$d521d3f5ee5a7baa,
    $5b23a7bd3e23e56e$export$96076d1ee44d366,
    $5b23a7bd3e23e56e$export$2da9139b7da400a3
]);

});

parcelRegister("de2j9", function(module, exports) {

$parcel$export(module.exports, "useIsEditorPage", () => $da4a5d353aff754e$export$90b90ac8ec152a49);

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");
const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>(0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);

});

parcelRegister("i6tGf", function(module, exports) {

$parcel$export(module.exports, "RightSidebarLoader", () => $3aa2dee10c94a2bd$export$a93b70acade45e11);

var $jmjWc = parcelRequire("jmjWc");

const $3aa2dee10c94a2bd$export$a93b70acade45e11 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Q11vO",
    name: "RightSidebarLoader",
    loader: async ()=>(await (parcelRequire("dncIn"))).RightSidebar
});

});
parcelRegister("dncIn", function(module, exports) {

let $9bc749390f0ce0b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $9bc749390f0ce0b9$var$load("7VyeJ"),
    $9bc749390f0ce0b9$var$load("feg87"),
    $9bc749390f0ce0b9$var$load("cJdPE"),
    $9bc749390f0ce0b9$var$load("kjZZD"),
    $9bc749390f0ce0b9$var$load("aGZFn"),
    $9bc749390f0ce0b9$var$load("c6MKV"),
    $9bc749390f0ce0b9$var$load("aZinD"),
    $9bc749390f0ce0b9$var$load("cyGuT"),
    $9bc749390f0ce0b9$var$load("6qah4"),
    $9bc749390f0ce0b9$var$load("ffEVr"),
    $9bc749390f0ce0b9$var$load("joJy8"),
    $9bc749390f0ce0b9$var$load("aHE9G"),
    $9bc749390f0ce0b9$var$load("jmmCO")
]).then(()=>parcelRequire('8tIfI'));

});


parcelRegister("JUk5P", function(module, exports) {

$parcel$export(module.exports, "SideNavigationSwitcher", () => $0d29c9a739c95b01$export$bcb01672fa577c2f);
/* SideNavigationSwitcher.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $cnSYc = parcelRequire("cnSYc");
var $jZM59 = parcelRequire("jZM59");

var $6zNhq = parcelRequire("6zNhq");

var $ljm2R = parcelRequire("ljm2R");

var $7uIhU = parcelRequire("7uIhU");

var $7zgzO = parcelRequire("7zgzO");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $bbp3G = parcelRequire("bbp3G");

var $hQnHK = parcelRequire("hQnHK");

var $de2j9 = parcelRequire("de2j9");

var $cEgMD = parcelRequire("cEgMD");

var $ep3mz = parcelRequire("ep3mz");

var $efvKr = parcelRequire("efvKr");

var $8zMP3 = parcelRequire("8zMP3");

var $2esS1 = parcelRequire("2esS1");
const $0d29c9a739c95b01$var$i18n = (0, $2nPZH.defineMessages)({
    collapseLabel: {
        id: "page-layout.sidebar.collapse.label",
        defaultMessage: "Collapse sidebar"
    },
    expandLabel: {
        id: "page-layout.sidebar.expand.label",
        defaultMessage: "Expand sidebar"
    },
    collapseTooltip: {
        id: "page-layout.sidebar.tooltip.collapse",
        defaultMessage: "Collapse"
    },
    expandTooltip: {
        id: "page-layout.sidebar.tooltip.expand",
        defaultMessage: "Expand"
    }
});
const $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH = 240;
const $0d29c9a739c95b01$var$ExpandKeyboardShortcut = ()=>{
    const [readyForToggle, setReadyForToggle] = (0, $gwFzn.useState)(true);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed, expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const toggleSidebarCollapse = (0, $gwFzn.useCallback)(()=>{
        if (readyForToggle) {
            if (isLeftSidebarCollapsed) expandLeftSidebar();
            else collapseLeftSidebar();
            setReadyForToggle(false);
            setTimeout(()=>setReadyForToggle(true), 350);
        }
    }, [
        isLeftSidebarCollapsed,
        expandLeftSidebar,
        collapseLeftSidebar,
        readyForToggle
    ]);
    const toggle = (0, $gwFzn.useCallback)(()=>{
        if (!(0, $bbp3G.isDialogShown)()) {
            toggleSidebarCollapse();
            setReadyForToggle(false);
            setTimeout(()=>setReadyForToggle(true), 350);
        }
    }, [
        toggleSidebarCollapse
    ]);
    return isLiveEditMode || isOnEditRoute ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutListener), {
        accelerator: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
        listener: toggle
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: [
            (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
            (0, $ljm2R.SIDE_NAVIGATION_SHORTCUT)
        ],
        listener: toggle
    });
};
//SidebarWrapper is a SUPER common Component name in AK
const $0d29c9a739c95b01$var$confSidebarWrapperStyles = null;
const $0d29c9a739c95b01$var$useSideNavState = ()=>{
    const { isPanelOpen: isPanelOpen, isDismissed: isDismissed } = (0, $6zNhq.useQuickstartState)();
    const shouldForceExpand = isPanelOpen && !isDismissed;
    const persistedCollapseState = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) ?? 'expanded';
    const persistedWidth = parseInt((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH //can return null
    ) || $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH, 10);
    const initialCollapsedState = shouldForceExpand ? 'expanded' : persistedCollapseState;
    const fittedSidebarWidth = persistedWidth > window.innerWidth ? $0d29c9a739c95b01$var$DEFAULT_SIDEBAR_WIDTH : persistedWidth;
    return {
        initialCollapsedState: initialCollapsedState,
        initialWidth: fittedSidebarWidth,
        shouldForceExpand: shouldForceExpand
    };
};
const $0d29c9a739c95b01$var$useSideNavEnabled = (view)=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return match?.query?.mode !== 'global' && view && [
        (0, $2esS1.CONTAINER_HOME_ID),
        (0, $2esS1.CONTAINER_BLOG_ID),
        (0, $2esS1.CONTAINER_HOME_LOADING_ID),
        (0, $2esS1.ADMIN_HOME_ID)
    ].includes(view) && // The side nav is not desirable in Company Hub, because it hides its space from the user.
    // But only CONTAINER_XXX represent space-related side navs, ADMIN_HOME_ID is for site-related admin side nav.
    (!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || view === (0, $2esS1.ADMIN_HOME_ID));
};
const $0d29c9a739c95b01$var$useSideNavResize = (shouldForceExpand)=>{
    const { expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)(); // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
    // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
    const onResizeStart = (0, $gwFzn.useCallback)(()=>{
        document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.setProperty('pointer-events', 'none');
    }, []);
    const onResizeEnd = (0, $gwFzn.useCallback)((leftSidebarState)=>{
        // CCT-951 TEMPORARY WORKAROUND to allow resizing of side-nav when viewing a Whiteboard (rendered in an iFrame)
        // Can be removed when DSP-5931 is fixed and @atlaskit/page-layout is bumped
        document.querySelector(`iframe[title="${(0, $hQnHK.WHITEBOARD_IFRAME_TITLE)}"]`)?.style.removeProperty('pointer-events');
        (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_WIDTH, leftSidebarState.leftSidebarWidth);
        if (shouldForceExpand && !leftSidebarState.leftSidebarWidth) expandLeftSidebar();
    }, [
        shouldForceExpand,
        expandLeftSidebar
    ]);
    return {
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    };
};
const $0d29c9a739c95b01$var$getSideNavigation = (view, isSpaceSettingsScreen)=>{
    switch(view){
        case 0, $2esS1.CONTAINER_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
                isSpaceSettingsScreen: isSpaceSettingsScreen
            });
        case 0, $2esS1.CONTAINER_BLOG_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigation), {
                isBlogNavigation: true,
                isSpaceSettingsScreen: false
            });
        case 0, $2esS1.CONTAINER_HOME_LOADING_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.SpaceNavigationLoadingSkeleton), null);
        case 0, $2esS1.ADMIN_HOME_ID:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7uIhU.AdminNavigationLoader), null);
    }
    return null;
};
const $0d29c9a739c95b01$export$bcb01672fa577c2f = ({ view: view, skiplinkText: skiplinkText, isSpaceSettingsScreen: isSpaceSettingsScreen = false })=>{
    const isSideNavEnabled = $0d29c9a739c95b01$var$useSideNavEnabled(view);
    const { initialCollapsedState: initialCollapsedState, initialWidth: initialWidth, shouldForceExpand: shouldForceExpand } = $0d29c9a739c95b01$var$useSideNavState();
    const { onResizeStart: onResizeStart, onResizeEnd: onResizeEnd } = $0d29c9a739c95b01$var$useSideNavResize(shouldForceExpand);
    const sideNavigation = $0d29c9a739c95b01$var$getSideNavigation(view, isSpaceSettingsScreen);
    const intl = (0, $dBxQj.default)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const getTooltipTextI18n = (isLeftSidebarCollapsed)=>isLeftSidebarCollapsed ? $0d29c9a739c95b01$var$i18n.expandTooltip : $0d29c9a739c95b01$var$i18n.collapseTooltip;
    const getExpanderButtonLabelI18n = (isLeftSidebarCollapsed)=>isLeftSidebarCollapsed ? $0d29c9a739c95b01$var$i18n.expandLabel : $0d29c9a739c95b01$var$i18n.collapseLabel;
    return isSideNavEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        className: (0, $35pXk.default)([
            "_11q711bn _1pbyilow _kf1jmuej _xlsvt94y _1pevt94y _1brykb7n _jj8pidpf _e1qhidpf _11mwf6fq _smi9go27 _qd9hvuon"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cnSYc.default), {
        testId: "grid-left-sidebar",
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd,
        width: initialWidth,
        collapsedState: initialCollapsedState,
        skipLinkTitle: skiplinkText,
        id: "AkSideNavigation",
        overrides: {
            ResizeButton: {
                render: (Component, props)=>shouldForceExpand ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                            contentBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), getTooltipTextI18n(props.isLeftSidebarCollapsed)),
                            shortcut: (0, $ljm2R.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                            isEditorShortcut: isOnEditRoute,
                            isTooltip: true
                        }),
                        hideTooltipOnClick: true,
                        position: "right",
                        testId: "sidebar-collapse-tooltip",
                        ignoreTooltipPointerEvents: true
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Component, {
                        "aria-label": intl.formatMessage(getExpanderButtonLabelI18n(props.isLeftSidebarCollapsed)),
                        ...props
                    }))
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "side-navigation"
    }, sideNavigation), !shouldForceExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($0d29c9a739c95b01$var$ExpandKeyboardShortcut, null))) : null;
};

});
parcelRegister("cnSYc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e84c623a4762216$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $cr6pC = parcelRequire("cr6pC");

var $ig6yX = parcelRequire("ig6yX");

var $fFc6D = parcelRequire("fFc6D");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $fS0n4 = parcelRequire("fS0n4");
var $jZM59 = parcelRequire("jZM59");
var $1HIA2 = parcelRequire("1HIA2");

var $eNyVi = parcelRequire("eNyVi");

var $kCXTI = parcelRequire("kCXTI");

var $c7KQg = parcelRequire("c7KQg");

var $bNGOo = parcelRequire("bNGOo");

var $gXiBW = parcelRequire("gXiBW");
const $3e84c623a4762216$var$openBackdropStyles = (0, $3jLHL.css)({
    width: '100%',
    height: '100%',
    position: 'absolute',
    background: `var(--ds-blanket, ${(0, $6fnsQ.N100A)})`,
    opacity: 1
});
const $3e84c623a4762216$var$hiddenBackdropStyles = (0, $3jLHL.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
/**
 * __Left sidebar__
 *
 * Provides a slot for a left sidebar within the PageLayout.
 *
 * On smaller viewports, the left sidebar can no longer be expanded.  Instead, expanding it will
 * put it into our "flyout mode" to lay overtop (which in desktop is explicitly a hover state).
 * This ensures the contents behind do not reflow oddly and allows for a better experience
 * resizing between mobile and desktop.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 */ const $3e84c623a4762216$var$LeftSidebar = (props)=>{
    const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
    const flyoutTimerRef = (0, $gwFzn.useRef)();
    const mouseOverEventRef = (0, $gwFzn.useRef)();
    const leftSideBarRef = (0, $gwFzn.useRef)(null);
    const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, hasInit: hasInit } = leftSidebarState;
    const isLocked = flyoutLockCount > 0;
    const isLockedRef = (0, $gwFzn.useRef)(isLocked);
    const mouseXRef = (0, $gwFzn.useRef)(0);
    const handlerRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        isLockedRef.current = isLocked;
        // I tried a one-time `mousemove` handler that gets attached
        // when the lock releases. This is not robust because
        // the mouse can stay still after release (e.g. using keyboard)
        // and the sidebar will erroneously stay open.
        //
        // The following solution is likely less performant but more robust.
        if (isLocked && !handlerRef.current) {
            handlerRef.current = (event)=>{
                mouseXRef.current = event.clientX;
            };
            document.addEventListener('mousemove', handlerRef.current);
        }
        if (!isLocked && handlerRef.current) {
            if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
            document.removeEventListener('mousemove', handlerRef.current);
            handlerRef.current = null;
        }
        return ()=>{
            if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
        };
    }, [
        isLocked,
        lastLeftSidebarWidth,
        setLeftSidebarState
    ]);
    const _width = Math.max(width || 0, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH));
    const collapsedStateOverrideOpen = collapsedState === 'expanded';
    let leftSidebarWidthOnMount;
    if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
    else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH);
    else leftSidebarWidthOnMount = (0, $nP1jF.resolveDimension)((0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, $nP1jF.getGridStateFromStorage)('isLeftSidebarCollapsed'));
    // Update state from cache on mount
    (0, $gwFzn.useEffect)(()=>{
        const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, $nP1jF.getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
        const cachedGridState = (0, $nP1jF.getGridStateFromStorage)('gridState') || {};
        let leftSidebarWidth = !width && cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT], (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        const lastLeftSidebarWidth = !width && cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT], (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
        if (cachedCollapsedState) leftSidebarWidth = (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH);
        setLeftSidebarState({
            isFlyoutOpen: false,
            isResizing: isResizing,
            isLeftSidebarCollapsed: cachedCollapsedState,
            leftSidebarWidth: leftSidebarWidth,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            flyoutLockCount: 0,
            isFixed: isFixed,
            hasInit: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Every time other than mount,
    // update the local storage and css variables.
    const notFirstRun = (0, $gwFzn.useRef)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (notFirstRun.current) {
            (0, $fS0n4.default)({
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
            });
            (0, $nP1jF.mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
        }
        if (!notFirstRun.current) notFirstRun.current = true;
        return ()=>{
            removeMouseOverListener();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        id
    ]);
    const onMouseOver = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
        event.persist();
        flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
        if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
            const leftSidebar = leftSideBarRef.current;
            if (leftSidebar === null || isLockedRef.current) return;
            if (!leftSidebar.contains(event.target)) {
                flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                onFlyoutCollapse && onFlyoutCollapse();
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                removeMouseOverListener();
            }
        };
        document.addEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
        flyoutTimerRef.current = setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: true
                }));
            onFlyoutExpand && onFlyoutExpand();
        }, (0, $i72d6.FLYOUT_DELAY));
    };
    const removeMouseOverListener = ()=>{
        mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
            capture: true,
            passive: true
        });
    };
    (0, $1HIA2.useSkipLink)(id, skipLinkTitle);
    const onMouseLeave = (event)=>{
        const isMouseOnResizeButton = event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, $i72d6.RESIZE_BUTTON_SELECTOR)}] *`);
        if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
        onFlyoutCollapse && onFlyoutCollapse();
        setTimeout(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    isFlyoutOpen: false
                }));
        }, (0, $i72d6.FLYOUT_DELAY));
    };
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    const openMobileFlyout = (0, $gwFzn.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: true
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    const closeMobileFlyout = (0, $gwFzn.useCallback)(()=>{
        if (!mobileMediaQuery?.matches) return;
        setLeftSidebarState((current)=>{
            if (!current.isFlyoutOpen) return current;
            return {
                ...current,
                isFlyoutOpen: false
            };
        });
    }, [
        setLeftSidebarState,
        mobileMediaQuery
    ]);
    (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm', (event)=>{
        setLeftSidebarState((current)=>{
            if (event.matches && !current.isLeftSidebarCollapsed) // Sidebar was previously open when resizing downwards, convert the sidebar being open to a flyout being open
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: current.leftSidebarWidth,
                isFlyoutOpen: true
            };
            else if (!event.matches && current.isFlyoutOpen) // The user is resizing "upwards", eg. going from mobile to desktop.
            // Flyout was previously open, let's keep it open by moving to the un-collapsed sidebar instead
            return {
                ...current,
                isResizing: false,
                isLeftSidebarCollapsed: false,
                leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)),
                isFlyoutOpen: false
            };
            return current;
        });
    });
    // Close the flyout when the "escape" key is pressed.
    (0, $cr6pC.default)({
        onClose: closeMobileFlyout,
        isDisabled: !isFlyoutOpen
    });
    /**
   * We use both the state and our effect-based ref to protect animation until initialized fully
   */ const isReady = hasInit && notFirstRun.current;
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, mobileMediaQuery?.matches && /**
     * On desktop, the `onClick` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $3e84c623a4762216$var$hiddenBackdropStyles,
            isFlyoutOpen && $3e84c623a4762216$var$openBackdropStyles
        ],
        onClick: closeMobileFlyout
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $c7KQg.default), {
        ref: leftSideBarRef,
        testId: testId,
        onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
        onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
        onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
        id: id,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gXiBW.default), {
        variableName: (0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH),
        value: isReady ? leftSidebarWidth : leftSidebarWidthOnMount,
        mobileValue: (0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
    }), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $kCXTI.default), {
        isFixed: isFixed,
        isFlyoutOpen: isFlyoutOpen
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $bNGOo.default), {
        isFlyoutOpen: isFlyoutOpen,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        hasCollapsedState: !isReady && collapsedState === 'collapsed',
        testId: testId && `${testId}-resize-children-wrapper`
    }, children), /*#__PURE__*/ (0, $3jLHL.jsx)((0, $eNyVi.default), {
        testId: testId,
        valueTextLabel: valueTextLabel,
        resizeGrabAreaLabel: resizeGrabAreaLabel,
        resizeButtonLabel: resizeButtonLabel,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        onResizeStart: onResizeStart,
        onResizeEnd: onResizeEnd
    }))));
};
var $3e84c623a4762216$export$2e2bcd8739ae039 = $3e84c623a4762216$var$LeftSidebar;

});
parcelRegister("eNyVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9398dc1f044e7907$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $d8F95 = parcelRequire("d8F95");

var $2ZsRZ = parcelRequire("2ZsRZ");

var $fFc6D = parcelRequire("fFc6D");

var $i72d6 = parcelRequire("i72d6");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");

var $iTa1r = parcelRequire("iTa1r");

var $el48X = parcelRequire("el48X");

var $aMx71 = parcelRequire("aMx71");
const $9398dc1f044e7907$var$cssSelector = {
    [(0, $i72d6.RESIZE_CONTROL_SELECTOR)]: true
};
const $9398dc1f044e7907$var$resizeControlStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: '100%',
    outline: 'none'
});
const $9398dc1f044e7907$var$showResizeButtonStyles = (0, $3jLHL.css)({
    '--ds--resize-button--opacity': 1
});
// @ts-expect-error adding `!important` to style rules is currently a type error
const $9398dc1f044e7907$var$globalResizingStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '*': {
        // Setting the cursor to be `ew-resize` on all elements so that even if the user
        // pointer slips off the resize handle, the cursor will still be the resize cursor
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        cursor: 'ew-resize !important',
        // Blocking selection while resizing
        // Notes:
        // - This prevents a user selection being caused by resizing
        // - Safari + Firefox → all good
        // - Chrome → This will undo the current selection while resizing (not ideal)
        //   - The current selection will resume after resizing
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        userSelect: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    iframe: {
        // Disabling pointer events on iframes when resizing
        // as iframes will swallower user events when the user is over them
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        pointerEvents: 'none !important'
    }
});
const $9398dc1f044e7907$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
    const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
    const sidebarWidth = (0, $gwFzn.useRef)(leftSidebarState[0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH]);
    // Distance of mouse from left sidebar onMouseDown
    const offset = (0, $gwFzn.useRef)(0);
    const keyboardEventTimeout = (0, $gwFzn.useRef)();
    const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $gwFzn.useState)(false);
    const unbindEvents = (0, $gwFzn.useRef)(null);
    const mobileMediaQuery = (0, $fFc6D.UNSAFE_useMediaQuery)('below.sm');
    // Used in some cases to ensure function references don't have to change
    // TODO: more functions could use `stableSidebarState` rather than `leftSidebarState`
    const stableSidebarState = (0, $gwFzn.useRef)(leftSidebarState);
    (0, $gwFzn.useEffect)(()=>{
        stableSidebarState.current = leftSidebarState;
    }, [
        leftSidebarState
    ]);
    const toggleSideBar = (0, $gwFzn.useCallback)((event)=>{
        // don't cascade down to the LeftSidebarOuter
        event?.stopPropagation();
        toggleLeftSidebar();
    }, [
        toggleLeftSidebar
    ]);
    const onMouseDown = (event)=>{
        if (isLeftSidebarCollapsed) return;
        // Only allow left (primary) clicks to trigger resize as we've received
        // bug reports about right click unexpectedly beginning a resize.
        if (event.button !== 0) return;
        // It is possible for a mousedown to fire during a resize
        // Example: the user presses another pointer button while dragging
        if (leftSidebarState.isResizing) // the resize will be cancelled by our global event listeners
        return;
        offset.current = event.clientX - leftSidebarState[0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH] - (0, $nP1jF.getLeftPanelWidth)();
        unbindEvents.current = (0, $d8F95.bindAll)(window, [
            {
                type: 'mousemove',
                listener: function(event) {
                    onUpdateResize({
                        clientX: event.clientX
                    });
                }
            },
            {
                type: 'mouseup',
                listener: onFinishResizing
            },
            {
                type: 'mousedown',
                // this mousedown event listener is being added in the bubble phase
                // on a higher event target than the resize handle.
                // This means that the original mousedown event that triggers a resize
                // can hit this mousedown handler. To get around that, we only call
                // `onFinishResizing` after an animation frame so we don't pick up the original event
                // Alternatives:
                // 1. Add the window 'mousedown' event listener in the capture phase
                // 👎 A 'mousedown' during a resize would trigger a new resize to start
                // 2. Do 1. and call `event.preventDefault()`, then check for `event.defaultPrevented` inside
                // the grab handle `onMouseDown`
                // 👎 Not ideal to cancel events if we don't have to
                listener: (()=>{
                    let hasFramePassed = false;
                    requestAnimationFrame(()=>{
                        hasFramePassed = true;
                    });
                    return function listener() {
                        if (hasFramePassed) onFinishResizing();
                    };
                })()
            },
            {
                type: 'visibilitychange',
                listener: onFinishResizing
            },
            // A 'click' event should never be hit as the 'mouseup' will come first and cause
            // these event listeners to be unbound. I just added 'click' for extreme safety (paranoia)
            {
                type: 'click',
                listener: onFinishResizing
            },
            {
                type: 'keydown',
                listener: (event)=>{
                    // Can cancel resizing by pressing "Escape"
                    // Will return sidebar to the same size it was before the resizing started
                    if (event.key === 'Escape') {
                        sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH));
                        document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                        onFinishResizing();
                    }
                }
            }
        ]);
        document.documentElement.setAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING), 'true');
        const newLeftbarState = {
            ...leftSidebarState,
            isResizing: true
        };
        setLeftSidebarState(newLeftbarState);
        onResizeStart && onResizeStart(newLeftbarState);
    };
    const onResizeOffLeftOfScreen = ()=>{
        onUpdateResize.cancel();
        unbindEvents.current?.();
        unbindEvents.current = null;
        document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING));
        offset.current = 0;
        collapseLeftSidebar(undefined, true);
    };
    // It is important that `onUpdateResize` is a stable function reference, so that:
    // 1. we ensure we are correctly throttling with `requestAnimationFrame`
    // 2. that a `onUpdateResize` will cancel the one and only pending frame
    // To help ensure `onUpdateResize` is stable, we are putting the last state into a ref
    const [onUpdateResize] = (0, $gwFzn.useState)(()=>(0, $2ZsRZ.default)(({ clientX: clientX })=>{
            // Allow the sidebar to be 50% of the available page width
            const maxWidth = Math.round(window.innerWidth / 2);
            const leftPanelWidth = (0, $nP1jF.getLeftPanelWidth)();
            const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
            const hasResizedOffLeftOfScreen = clientX < 0;
            if (hasResizedOffLeftOfScreen) {
                onResizeOffLeftOfScreen();
                return;
            }
            const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
            sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH));
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
        }));
    const onFinishResizing = ()=>{
        if (isLeftSidebarCollapsed) return;
        document.documentElement.removeAttribute((0, $i72d6.IS_SIDEBAR_DRAGGING));
        // TODO: the control flow is pretty strange as the first codepath which calls `collapseLeftSidebar()`
        // does not return an updated state snapshot.
        let updatedLeftSidebarState = null;
        // If it is dragged to below the threshold,
        // collapse the navigation
        if (sidebarWidth.current < (0, $i72d6.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
            // TODO: for this codepath, `onCollapse` occurs before `onResizeEnd` which seems wrong
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
            collapseLeftSidebar(undefined, true);
        } else if (sidebarWidth.current > (0, $i72d6.MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
            document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)
            };
            setLeftSidebarState(updatedLeftSidebarState);
        } else {
            // otherwise resize it to the desired width
            updatedLeftSidebarState = {
                ...leftSidebarState,
                isResizing: false,
                [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                lastLeftSidebarWidth: sidebarWidth.current
            };
            setLeftSidebarState(updatedLeftSidebarState);
        }
        unbindEvents.current?.();
        unbindEvents.current = null;
        onUpdateResize.cancel();
        sidebarWidth.current = 0;
        offset.current = 0;
        // TODO: no idea why this is in an animation frame
        requestAnimationFrame(()=>{
            setIsGrabAreaFocused(false);
            // Note: the `collapseSidebar` codepath does not return state, so we need to pull it from the ref
            onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
        });
    };
    const onKeyDown = (event)=>{
        if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
        const { key: key } = event;
        const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
        const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
        const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
        if (isSpaceOrEnter) {
            toggleSideBar(event);
            event.preventDefault();
        }
        if (isLeftOrTopArrow || isRightOrBottomArrow) {
            event.preventDefault(); // prevent content scroll
            onResizeStart && onResizeStart(leftSidebarState);
            const step = 10;
            const stepValue = isLeftOrTopArrow ? -step : step;
            const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
            const maxWidth = Math.round(window.innerWidth / 2) - (0, $nP1jF.getLeftPanelWidth)();
            const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
            let width = leftSidebarWidth + stepValue;
            if (width <= (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                width = (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH);
                document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
            } else if (width > maxWidth) {
                width = maxWidth;
                document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
            } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, $i72d6.DEFAULT_LEFT_SIDEBAR_WIDTH);
            // Nesting the setTimeout within requestAnimationFrame helps
            // the browser schedule the setTimeout call in an efficient manner
            requestAnimationFrame(()=>{
                keyboardEventTimeout.current = window.setTimeout(()=>{
                    keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                    document.documentElement.style.setProperty(`--${(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                    const updatedLeftSidebarState = {
                        ...leftSidebarState,
                        [(0, $i72d6.VAR_LEFT_SIDEBAR_WIDTH)]: width,
                        lastLeftSidebarWidth: width
                    };
                    setLeftSidebarState(updatedLeftSidebarState);
                    onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                }, 50);
            });
        }
    };
    const onFocus = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(true);
    }, []);
    const onBlur = (0, $gwFzn.useCallback)(()=>{
        setIsGrabAreaFocused(false);
    }, []);
    const resizeButton = {
        render: (Component, props)=>/*#__PURE__*/ (0, $3jLHL.jsx)(Component, props),
        ...overrides && overrides.ResizeButton
    };
    // This width is calculated once only on mount.
    // This means resizing the window will cause this value to be incorrect for screen reader users,
    // however this comes with a substantial performance gain and so is considered acceptable.
    const maxAriaWidth = (0, $gwFzn.useMemo)(()=>{
        const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
        return Math.round(innerWidth / 2) - (0, $nP1jF.getLeftPanelWidth)();
    }, []);
    const leftSidebarPercentageExpanded = (0, $nP1jF.getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        ...$9398dc1f044e7907$var$cssSelector,
        css: [
            $9398dc1f044e7907$var$resizeControlStyles,
            (isGrabAreaFocused || isLeftSidebarCollapsed) && $9398dc1f044e7907$var$showResizeButtonStyles
        ]
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $aMx71.default), {
        testId: testId && `${testId}-shadow`
    }), // Only show the GrabArea if we're not on the mobile viewport
    !mobileMediaQuery?.matches && /*#__PURE__*/ (0, $3jLHL.jsx)((0, $iTa1r.default), {
        isDisabled: isLeftSidebarCollapsed,
        isLeftSidebarCollapsed: isLeftSidebarCollapsed,
        label: resizeGrabAreaLabel,
        valueTextLabel: valueTextLabel,
        leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        testId: testId && `${testId}-grab-area`
    }), resizeButton.render((0, $el48X.default), {
        isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
        label: resizeButtonLabel,
        onClick: toggleSideBar,
        testId: testId && `${testId}-resize-button`
    })), leftSidebarState.isResizing ? /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3jLHL.Global), {
        styles: $9398dc1f044e7907$var$globalResizingStyles
    }) : null);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9398dc1f044e7907$export$2e2bcd8739ae039 = $9398dc1f044e7907$var$ResizeControl;

});
parcelRegister("iTa1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $982ec4d5608019c5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");
/**
 * Determines the color of the grab line.
 *
 * Used on internal leaf node, so naming collisions won't matter.
 */ const $982ec4d5608019c5$var$varLineColor = '--ds-line';
const $982ec4d5608019c5$var$grabAreaStyles = (0, $3jLHL.css)({
    width: "var(--ds-space-200, 16px)",
    height: '100%',
    padding: 0,
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'ew-resize',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:focus': {
        outline: 0
    },
    '&:enabled:hover, &:enabled:focus, &:enabled:active': {
        [$982ec4d5608019c5$var$varLineColor]: `var(--ds-border-selected, ${(0, $6fnsQ.B200)})`
    }
});
const $982ec4d5608019c5$var$grabAreaCollapsedStyles = (0, $3jLHL.css)({
    height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
    padding: 0,
    position: 'absolute',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'default',
    insetBlockEnd: 0
});
const $982ec4d5608019c5$var$lineStyles = (0, $3jLHL.css)({
    display: 'block',
    width: "var(--ds-border-width-outline, 2px)",
    height: '100%',
    backgroundColor: 'var(--ds-line)',
    transition: 'background-color 200ms'
});
const $982ec4d5608019c5$var$grabAreaLineSelector = {
    [(0, $i72d6.GRAB_AREA_LINE_SELECTOR)]: true
};
const $982ec4d5608019c5$var$grabAreaSelector = {
    [(0, $i72d6.GRAB_AREA_SELECTOR)]: true
};
const $982ec4d5608019c5$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>/*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        ...$982ec4d5608019c5$var$grabAreaSelector,
        "aria-label": label,
        "data-testid": testId,
        disabled: isDisabled,
        "aria-hidden": isLeftSidebarCollapsed,
        type: "button",
        // The slider role is applied to a button to utilize the native
        // interactive and disabled functionality on the resize slider. While a
        // range input would be more semantically accurate, it does not affect
        // usability.
        role: "slider",
        css: [
            $982ec4d5608019c5$var$grabAreaStyles,
            isLeftSidebarCollapsed && $982ec4d5608019c5$var$grabAreaCollapsedStyles
        ],
        "aria-orientation": "vertical",
        "aria-valuenow": leftSidebarPercentageExpanded,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $982ec4d5608019c5$var$lineStyles,
        ...$982ec4d5608019c5$var$grabAreaLineSelector
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$982ec4d5608019c5$export$2e2bcd8739ae039 = $982ec4d5608019c5$var$GrabArea;

});

parcelRegister("el48X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b3f426c3b7b32cb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $ldIK0 = parcelRequire("ldIK0");

var $ig6yX = parcelRequire("ig6yX");

var $4c48T = parcelRequire("4c48T");

var $bWLcG = parcelRequire("bWLcG");

var $6fnsQ = parcelRequire("6fnsQ");

var $i72d6 = parcelRequire("i72d6");
const $3b3f426c3b7b32cb$var$increaseHitAreaStyles = (0, $3jLHL.css)({
    position: 'absolute',
    insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
    insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
    insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
    insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
});
const $3b3f426c3b7b32cb$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        opacity: 1
    }
});
const $3b3f426c3b7b32cb$var$resizeIconButtonStyles = (0, $3jLHL.css)({
    width: 24,
    height: 24,
    padding: "var(--ds-space-0, 0px)",
    position: 'absolute',
    backgroundColor: `var(--ds-surface-overlay, ${(0, $6fnsQ.N0)})`,
    border: 0,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    boxShadow: `0 0 0 1px ${(0, $6fnsQ.N30A)}, 0 2px 4px 1px ${(0, $6fnsQ.N30A)}`,
    color: `var(--ds-text-subtle, ${(0, $6fnsQ.N200)})`,
    cursor: 'pointer',
    insetBlockStart: "var(--ds-space-400, 32px)",
    insetInlineStart: 0,
    /**
   * The fallback value of 0 ensures that the button is hidden by default,
   * unless some parent (or the button itself) overrides it.
   */ opacity: `var(--ds--resize-button--opacity,0)`,
    outline: 0,
    transform: 'translateX(-50%)',
    transition: `
    background-color ${(0, $4c48T.durations).small}ms linear,
    color ${(0, $4c48T.durations).small}ms linear,
    opacity ${(0, $4c48T.durations).medium}ms ${(0, $ig6yX.easeOut)}
  `,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        backgroundColor: `var(--ds-background-selected-bold, ${(0, $6fnsQ.B100)})`,
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':active, :focus': {
        backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $6fnsQ.B200)})`,
        color: `var(--ds-text-inverse, ${(0, $6fnsQ.N0)})`,
        opacity: 1
    }
});
const $3b3f426c3b7b32cb$var$resizeIconButtonExpandedStyles = (0, $3jLHL.css)({
    transform: 'rotate(180deg)',
    transformOrigin: 7
});
const $3b3f426c3b7b32cb$var$preventDefault = (event)=>event.preventDefault();
const $3b3f426c3b7b32cb$var$cssSelector = {
    [(0, $i72d6.RESIZE_BUTTON_SELECTOR)]: true
};
const $3b3f426c3b7b32cb$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>/*#__PURE__*/ (0, $3jLHL.jsx)("button", {
        ...$3b3f426c3b7b32cb$var$cssSelector,
        "aria-expanded": !isLeftSidebarCollapsed,
        "aria-label": label,
        type: "button",
        // The error goes away when we remove the spread ...props
        css: [
            $3b3f426c3b7b32cb$var$resizeIconButtonStyles,
            $3b3f426c3b7b32cb$var$mobileStyles,
            !isLeftSidebarCollapsed && $3b3f426c3b7b32cb$var$resizeIconButtonExpandedStyles
        ],
        "data-testid": testId,
        // Prevents focus staying attached to the button when pressed
        onMouseDown: $3b3f426c3b7b32cb$var$preventDefault,
        ...props
    }, /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldIK0))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, $3jLHL.jsx)("span", {
        css: $3b3f426c3b7b32cb$var$increaseHitAreaStyles
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3b3f426c3b7b32cb$export$2e2bcd8739ae039 = $3b3f426c3b7b32cb$var$ResizeButton;

});

parcelRegister("aMx71", function(module, exports) {

$parcel$export(module.exports, "default", () => $a541337233c62c24$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");

var $gL4SZ = parcelRequire("gL4SZ");
const $a541337233c62c24$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
const $a541337233c62c24$var$direction = 'to left';
const $a541337233c62c24$var$transitionDuration = '0.22s';
const $a541337233c62c24$var$shadowStyles = (0, $3jLHL.css)({
    width: 3,
    position: 'absolute',
    background: `var(--ds-border, ${`linear-gradient(${$a541337233c62c24$var$direction}, ${$a541337233c62c24$var$colorStops})`})`,
    insetBlockEnd: 0,
    insetBlockStart: 0,
    insetInlineStart: -1,
    opacity: 0.5,
    pointerEvents: 'none',
    transitionDuration: $a541337233c62c24$var$transitionDuration,
    transitionProperty: 'left, opacity, width',
    transitionTimingFunction: (0, $ig6yX.easeOut)
});
const $a541337233c62c24$var$draggingStyles = (0, $3jLHL.css)({
    width: 6,
    background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$a541337233c62c24$var$direction}, ${$a541337233c62c24$var$colorStops})`})`,
    insetInlineStart: "var(--ds-space-negative-075, -6px)",
    opacity: 0.8
});
const $a541337233c62c24$var$Shadow = ({ testId: testId })=>{
    const isDragging = (0, $gL4SZ.default)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        "data-testid": testId,
        css: [
            $a541337233c62c24$var$shadowStyles,
            isDragging && $a541337233c62c24$var$draggingStyles
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a541337233c62c24$export$2e2bcd8739ae039 = $a541337233c62c24$var$Shadow;

});


parcelRegister("kCXTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b071e79511136d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $44b071e79511136d$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $44b071e79511136d$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $i72d6.BANNER_HEIGHT)} + ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $i72d6.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
    }
});
const $44b071e79511136d$var$mobileInnerFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s, box-shadow ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $44b071e79511136d$var$fixedInnerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $i72d6.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $i72d6.BANNER_HEIGHT)} + ${(0, $i72d6.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $i72d6.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`
});
const $44b071e79511136d$var$fixedInnerFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $44b071e79511136d$var$staticInnerStyles = (0, $3jLHL.css)({
    height: '100%'
});
const $44b071e79511136d$var$draggingStyles = (0, $3jLHL.css)({
    cursor: 'ew-resize',
    // Make sure drag to resize does not animate as the user drags
    transition: 'none'
});
const $44b071e79511136d$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $gL4SZ.default)();
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            // mobile viewport styles
            $44b071e79511136d$var$mobileStyles,
            isFlyoutOpen && $44b071e79511136d$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $44b071e79511136d$var$staticInnerStyles,
            isFixed && $44b071e79511136d$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $44b071e79511136d$var$fixedInnerFlyoutStyles,
            isDragging && $44b071e79511136d$var$draggingStyles,
            $44b071e79511136d$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$44b071e79511136d$export$2e2bcd8739ae039 = $44b071e79511136d$var$LeftSidebarInner;

});

parcelRegister("c7KQg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9783221131ba50b9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $3jLHL = parcelRequire("3jLHL");

var $ig6yX = parcelRequire("ig6yX");
var $7hpmn = parcelRequire("7hpmn");

var $bWLcG = parcelRequire("bWLcG");

var $i72d6 = parcelRequire("i72d6");

var $gL4SZ = parcelRequire("gL4SZ");

var $nP1jF = parcelRequire("nP1jF");

var $jZM59 = parcelRequire("jZM59");

var $3xCvY = parcelRequire("3xCvY");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $9783221131ba50b9$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
const $9783221131ba50b9$var$mobileStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $i72d6.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $i72d6.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $9783221131ba50b9$var$mobileFlyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $bWLcG.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $9783221131ba50b9$var$outerStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $i72d6.TRANSITION_DURATION)}ms ${(0, $ig6yX.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $9783221131ba50b9$var$draggingStyles = (0, $3jLHL.css)({
    cursor: 'ew-resize',
    // Make sure drag to resize does not animate as the user drags
    transition: 'none'
});
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $9783221131ba50b9$var$fixedStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $i72d6.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $9783221131ba50b9$var$flyoutStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $9783221131ba50b9$var$flyoutFixedStyles = (0, $3jLHL.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $i72d6.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $9783221131ba50b9$var$selector = (0, $nP1jF.getPageLayoutSlotSelector)('left-sidebar');
const $9783221131ba50b9$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $gL4SZ.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $gwFzn.useContext)((0, $jZM59.SidebarResizeContext));
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3xCvY.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
            css: [
                // mobile viewport styles
                $9783221131ba50b9$var$mobileStyles,
                isFlyoutOpen && $9783221131ba50b9$var$mobileFlyoutStyles,
                // generic styles
                $9783221131ba50b9$var$outerStyles,
                isFixed && $9783221131ba50b9$var$fixedStyles,
                isFlyoutOpen && $9783221131ba50b9$var$flyoutStyles,
                isFlyoutOpen && isFixed && $9783221131ba50b9$var$flyoutFixedStyles,
                isDragging && $9783221131ba50b9$var$draggingStyles,
                $9783221131ba50b9$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$9783221131ba50b9$var$selector
        }, children));
};
const $9783221131ba50b9$var$LeftSidebarOuter = /*#__PURE__*/ (0, $gwFzn.forwardRef)($9783221131ba50b9$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9783221131ba50b9$export$2e2bcd8739ae039 = $9783221131ba50b9$var$LeftSidebarOuter;

});

parcelRegister("bNGOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5caffb7635e842ca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $3jLHL = parcelRequire("3jLHL");

var $7hpmn = parcelRequire("7hpmn");

var $i72d6 = parcelRequire("i72d6");

var $6eYLc = parcelRequire("6eYLc");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $5caffb7635e842ca$var$prefersReducedMotionStyles = (0, $3jLHL.css)((0, $7hpmn.prefersReducedMotion)());
/**
 * The transition duration is intentionally set to 0ms.
 *
 * A transition is being used here to delay the setting of
 * opacity and visibility so that it syncs collapsing sidebar.
 */ const $5caffb7635e842ca$var$hideLeftSidebarContentsStyles = (0, $3jLHL.css)({
    opacity: 0,
    transition: 'opacity 0ms linear, visibility 0ms linear',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `${(0, $i72d6.TRANSITION_DURATION) - 100}ms`,
    visibility: 'hidden'
});
const $5caffb7635e842ca$var$resizableChildrenWrapperStyles = (0, $3jLHL.css)({
    height: '100%',
    opacity: 1,
    overflow: 'hidden auto',
    transition: 'none',
    visibility: 'visible'
});
const $5caffb7635e842ca$var$fixedChildrenWrapperStyles = (0, $3jLHL.css)({
    minWidth: 240,
    height: '100%'
});
const $5caffb7635e842ca$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
    const isCollapsing = (0, $6eYLc.default)();
    const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
    const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
    return /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: [
            $5caffb7635e842ca$var$resizableChildrenWrapperStyles,
            isHidden && $5caffb7635e842ca$var$hideLeftSidebarContentsStyles,
            $5caffb7635e842ca$var$prefersReducedMotionStyles
        ],
        "aria-hidden": isHidden,
        "data-testid": testId,
        tabIndex: isHidden ? -1 : 0
    }, /*#__PURE__*/ (0, $3jLHL.jsx)("div", {
        css: $5caffb7635e842ca$var$fixedChildrenWrapperStyles
    }, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5caffb7635e842ca$export$2e2bcd8739ae039 = $5caffb7635e842ca$var$ResizableChildrenWrapper;

});
parcelRegister("6eYLc", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb92c2c5934a1475$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $i72d6 = parcelRequire("i72d6");
const $cb92c2c5934a1475$var$getIsCollapsing = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $i72d6.IS_SIDEBAR_COLLAPSING)) === 'true';
};
const $cb92c2c5934a1475$var$useIsSidebarCollapsing = ()=>{
    const [isCollapsing, setIsCollapsing] = (0, $gwFzn.useState)($cb92c2c5934a1475$var$getIsCollapsing);
    (0, $gwFzn.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsCollapsing($cb92c2c5934a1475$var$getIsCollapsing);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $i72d6.IS_SIDEBAR_COLLAPSING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isCollapsing;
};
var $cb92c2c5934a1475$export$2e2bcd8739ae039 = $cb92c2c5934a1475$var$useIsSidebarCollapsing;

});



parcelRegister("hQnHK", function(module, exports) {

$parcel$export(module.exports, "TEMPLATE_PICKER_QUERY_PARAM", () => $0037b6bfd6daf741$export$8cda2e6ee87e510b);
$parcel$export(module.exports, "NEW_WHITEBOARD_QUERY_PARAM", () => $0037b6bfd6daf741$export$2deb4fd8c7cecd6b);
$parcel$export(module.exports, "INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM", () => $0037b6bfd6daf741$export$58465f9d39dce215);
$parcel$export(module.exports, "HEADLESS_QUERY_PARAM", () => $0037b6bfd6daf741$export$6b4bb9c01a5ea809);
$parcel$export(module.exports, "SERVER_SPOT_PARAM", () => $0037b6bfd6daf741$export$fe7e318da6d65170);
$parcel$export(module.exports, "RELAY_SPOT_PARAM", () => $0037b6bfd6daf741$export$f356f97db9b96f17);
$parcel$export(module.exports, "WHITEBOARD_IFRAME_TITLE", () => $0037b6bfd6daf741$export$1cebfc86ac630bb9);
$parcel$export(module.exports, "WHITEBOARD_LOCALE", () => $0037b6bfd6daf741$export$3078341395c8cb8e);
$parcel$export(module.exports, "WHITEBOARD_LINKED_OBJECT", () => $0037b6bfd6daf741$export$8103f24eb51911e7);
$parcel$export(module.exports, "INITIAL_THEME_PARAM", () => $0037b6bfd6daf741$export$d7fb875e30263264);
$parcel$export(module.exports, "BIFROST_OVERRIDE_PARAM", () => $0037b6bfd6daf741$export$abce116b94c493f9);
$parcel$export(module.exports, "PAYWALL_DEACTIVATION_IDENTIFIER", () => $0037b6bfd6daf741$export$d3cf0d39019c8c7f);
$parcel$export(module.exports, "WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID", () => $0037b6bfd6daf741$export$390fc29767c845fc);
$parcel$export(module.exports, "WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID", () => $0037b6bfd6daf741$export$7864364f55e7d48e);
$parcel$export(module.exports, "WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX", () => $0037b6bfd6daf741$export$4541324acb17bf12);
$parcel$export(module.exports, "JIRA_IMPORT_TOOL_QUERY_PARAM", () => $0037b6bfd6daf741$export$c896c362d8b74a87);
$parcel$export(module.exports, "MIRO_IMPORT_TOOL_QUERY_PARAM", () => $0037b6bfd6daf741$export$72b22303fb080064);
$parcel$export(module.exports, "CLOUD_ID", () => $0037b6bfd6daf741$export$cbbd90bf5df877bd);
$parcel$export(module.exports, "PROJECT_UUID", () => $0037b6bfd6daf741$export$2f0c01c772bbe851);
$parcel$export(module.exports, "PARENT_PRODUCT_QUERY_PARAM", () => $0037b6bfd6daf741$export$1c237a39a0b4e9d9);
$parcel$export(module.exports, "PARENT_DOMAIN_QUERY_PARAM", () => $0037b6bfd6daf741$export$2fe42b7bd8ad9641);
$parcel$export(module.exports, "EMBEDDED_THEME_STATE", () => $0037b6bfd6daf741$export$6c706ba208a447e);
$parcel$export(module.exports, "VISUAL_REFRESH_PARAM", () => $0037b6bfd6daf741$export$8b639ae03e233763);
$parcel$export(module.exports, "EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM", () => $0037b6bfd6daf741$export$628c002e5c2252ee);
$parcel$export(module.exports, "FOCUSED_COMMENT_ID", () => $0037b6bfd6daf741$export$cab138e355452790);
$parcel$export(module.exports, "REPLY_TO_COMMENT", () => $0037b6bfd6daf741$export$95e280144fb6ae44);
$parcel$export(module.exports, "WHITEBOARD_VERSION_ID", () => $0037b6bfd6daf741$export$4f5dbfe1c54c9e86);
$parcel$export(module.exports, "CREATED_FROM_SLUG", () => $0037b6bfd6daf741$export$4b9f8234d01d21e9);
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';

});

parcelRegister("8zMP3", function(module, exports) {

$parcel$export(module.exports, "SuspenseWithDataFetcher", () => $5cfe2edd168ef31e$export$553ede96e278ba94);

var $gwFzn = parcelRequire("gwFzn");

var $eS4vC = parcelRequire("eS4vC");
function $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    if (window.__SSR_REACT_STREAMING__) {
        const dataFetcher = (0, $eS4vC.getDataFetcherForSuspense)(dataFetcherName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Suspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
}

});
parcelRegister("eS4vC", function(module, exports) {

$parcel$export(module.exports, "getDataFetcherForSuspense", () => $a98f386ac75dbb32$export$63116239d47be9ca);
$parcel$export(module.exports, "createDataFetcherForSuspense", () => $a98f386ac75dbb32$export$51ac369f090007c2);

let $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated = 0;
function $a98f386ac75dbb32$export$63116239d47be9ca(dataFetcherName) {
    if (!window.__SSR_REACT_STREAMING__) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
function $a98f386ac75dbb32$export$51ac369f090007c2(dataFetcherName, promise) {
    promise = promise ?? Promise.resolve();
    if (Array.isArray(promise)) promise = Promise.all(promise);
    if (!window.__SSR_REACT_STREAMING__) return promise;
    if (!window.__dataFetcherForSuspense__) window.__dataFetcherForSuspense__ = {};
    const dataFetcher = window.__dataFetcherForSuspense__[dataFetcherName];
    if (!dataFetcher) {
        const urlParams = new URLSearchParams(window.location.search);
        const mockDelay = urlParams.get('MOCK_SUSPENSE_QUERYDELAY');
        // If MOCK_SUSPENSE_QUERYDELAY = 1000, we want first data fetcher to have delay of 1000ms then second one to have 2000ms
        // In this case, we can see the suspense is really working. They should appear piece by piece.
        $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated += mockDelay ? parseInt(mockDelay) : 0;
        window.__dataFetcherForSuspense__[dataFetcherName] = $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise, $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated);
    }
    return Promise.resolve();
}
function $a98f386ac75dbb32$export$b4f7405efb61c06d() {
    $a98f386ac75dbb32$var$mockSuspenseDelayAccumulated = 0;
}
function $a98f386ac75dbb32$export$728d3ea8195fe601(dataFetcherName, promise, delay = 0) {
    let dataResult = null;
    let errorResult = null;
    let promiseState = 'pending';
    const suspender = new Promise((resolve)=>{
        promise.then((result)=>{
            if (delay > 0) setTimeout(()=>{
                dataResult = result;
                promiseState = 'resolved';
                resolve();
            }, delay);
            else {
                dataResult = result;
                promiseState = 'resolved';
                resolve();
            }
        }).catch((error)=>{
            error.dataFetcherName = dataFetcherName;
            errorResult = error;
            promiseState = 'error';
            resolve();
        });
    });
    return {
        getError () {
            return errorResult;
        },
        read () {
            if (promiseState === 'pending') throw suspender;
            else if (promiseState === 'error') // Data fetcher is a wrapper of preloader. If an error happened we don't want to blow up the tree too early.
            // Return null here to signal the Suspense to continue.
            // The normal error handling in the component will take care of it.
            return null;
            else if (promiseState === 'resolved') return dataResult;
        }
    };
}

});




parcelRegister("aJPUt", function(module, exports) {

$parcel$export(module.exports, "ExperienceTimeout", () => $bcb0fe1d423eb4f4$export$5e180a90f8d3e374);
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 25000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});

});

parcelRegister("ivb8S", function(module, exports) {

$parcel$export(module.exports, "deserializeState", () => $6fc4b7bb962289cc$export$7ca8667598519375);
$parcel$export(module.exports, "useSetOnboardingState", () => $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf);
$parcel$export(module.exports, "useGetOnboardingState", () => $6fc4b7bb962289cc$export$d5e7611ac338ec84);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $7Sm4c = parcelRequire("7Sm4c");

var $8Lx5S = parcelRequire("8Lx5S");

var $cbOce = parcelRequire("cbOce");
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined) onboardingState.forEach(({ key: key, value: value })=>{
        // key comes back as "quickstart-state:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) return;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    });
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $j1Ss3.useMutation)((0, $d2LG0.default)`mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key value}}`, {
        update (cache, { data: data }) {
            const states = data.setOnboardingState;
            states.forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                cache.writeFragment({
                    id: `OnboardingState:${key}`,
                    fragment: (0, $d2LG0.default)`fragment myKey on OnboardingState{key value}`,
                    data: {
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    const setOnboardingState = (0, $gwFzn.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const skipQuery = skip || !isAllowed;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key value}}`, {
        variables: {
            key: key
        },
        skip: skipQuery
    });
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};

});
parcelRegister("8Lx5S", function(module, exports) {

$parcel$export(module.exports, "useIsLicensed", () => $30f02aa82d7102bc$export$ac4f65b11c57a33b);
$parcel$export(module.exports, "useIsGuest", () => $30f02aa82d7102bc$export$f9ffae90e66d63e);
$parcel$export(module.exports, "useAccessStatus", () => $30f02aa82d7102bc$export$41f8700aabec6a40);

var $bQm3c = parcelRequire("bQm3c");

var $d9tcB = parcelRequire("d9tcB");
/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 * @warning ⚠️ This field is not available in the query preloader in SSR. Do not rely on it to skip preloader queries in SSR.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};

});

parcelRegister("cbOce", function(module, exports) {

$parcel$export(module.exports, "isExpectedError", () => $2f49c1e50cca9335$export$8715824c16ceeca0);

var $flE5X = parcelRequire("flE5X");

var $dIouf = parcelRequire("dIouf");
function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $dIouf.isUnauthorizedError)(error);
    return isUnauthorized || (0, $flE5X.containsNoNetworkError)(error);
}

});


parcelRegister("7aRa9", function(module, exports) {

$parcel$export(module.exports, "withFlags", () => $eb37d7497b3d263d$export$e624a3067d475d88);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $gqqjz = parcelRequire("gqqjz");
function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $gwFzn.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}

});

parcelRegister("dBcar", function(module, exports) {

$parcel$export(module.exports, "PEOPLE", () => $3c94963df51c0e13$export$f35f2899eb1390e3);
$parcel$export(module.exports, "FIRST_SPACE_SELECTED", () => $3c94963df51c0e13$export$1f72e9a162b3795b);
$parcel$export(module.exports, "HELP", () => $3c94963df51c0e13$export$da223e550b96c9d6);
$parcel$export(module.exports, "ONBOARDING_INTENTS", () => $3c94963df51c0e13$export$ffb6b379ff35f9e);
$parcel$export(module.exports, "ONBOARDING_INTENT_EXPERIENCES", () => $3c94963df51c0e13$export$49ac0bbeb4be0a06);
$parcel$export(module.exports, "ONBOARDING_REVERSE_TRIAL", () => $3c94963df51c0e13$export$6167e5b70dfd11d9);
$parcel$export(module.exports, "TEMPLATES_COLLECTION", () => $3c94963df51c0e13$export$49c044e5e3ccc2af);
$parcel$export(module.exports, "SPACE_GETTING_STARTED_TOUR_EXPERIENCES", () => $3c94963df51c0e13$export$dcbccfe8799c3c7b);
$parcel$export(module.exports, "PERSISTENT_INVITE", () => $3c94963df51c0e13$export$305c55ea55928edf);
$parcel$export(module.exports, "IS_NAV_4_GLOBAL_SPOTLIGHT_DISMISSED", () => $3c94963df51c0e13$export$b99b309b286adebc);
$parcel$export(module.exports, "IS_NAV_4_SPACE_TOUR_DISMISSED", () => $3c94963df51c0e13$export$20b0548cf5859d6);
$parcel$export(module.exports, "IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED", () => $3c94963df51c0e13$export$4d93dfc1d8538d55);
$parcel$export(module.exports, "WHATS_NEW_IN_CONFLUENCE", () => $3c94963df51c0e13$export$7ed75560092630f6);
$parcel$export(module.exports, "MODERNIZE_CONFLUENCE_IPM_MODAL", () => $3c94963df51c0e13$export$cba7fd986c721ece);
$parcel$export(module.exports, "NTH_USER_SETUP_CONTENT_TYPE", () => $3c94963df51c0e13$export$d1ec748fb682ca97);
$parcel$export(module.exports, "PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED", () => $3c94963df51c0e13$export$1a3a43cef0acd011);
$parcel$export(module.exports, "FEATURE_DISCOVERY_CONTEXTUAL_CREATE_MENU_SUBTEXT", () => $3c94963df51c0e13$export$4d9719b9c3bbb6d3);
$parcel$export(module.exports, "ONBOARDING_EXPERIENCES", () => $3c94963df51c0e13$export$bfeb2da96277b623);
$parcel$export(module.exports, "COMPLETE", () => $3c94963df51c0e13$export$1660a2d7c2fff354);
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$bcc4454330a6e241 = 'isContentWrapperLabelsTourDismissed';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$cba7fd986c721ece = {
    HAS_DISMISSED_MODAL: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceIpmModal',
    HAS_DISMISSED_BANNER: 'modernize-confluence-ipm-modal:hasDismissedModernizeConfluenceBanner'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$4d9719b9c3bbb6d3 = {
    WAS_VARIANT_GROUP: 'contextual-create-menu-subtext:wasVariantGroup'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    IS_CONTENT_WRAPPER_LABELS_TOUR_DISMISSED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$bcc4454330a6e241}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const { LEGACY_ONBOARDING_STATE: $3c94963df51c0e13$export$66aa87593037fd4a } = $3c94963df51c0e13$export$bfeb2da96277b623;

});

parcelRegister("luv00", function(module, exports) {

$parcel$export(module.exports, "useSSRPlaceholderReplaceIdProp", () => $8a88875ffe13fd4c$export$30b62f74ca853d7d);

var $gwFzn = parcelRequire("gwFzn");

var $5nSna = parcelRequire("5nSna");
function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $gwFzn.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}

});

parcelRegister("5X6QO", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("eOL5r")).disableNativeDragPreview);

var $eOL5r = parcelRequire("eOL5r");

});
parcelRegister("eOL5r", function(module, exports) {

$parcel$export(module.exports, "disableNativeDragPreview", () => $20c6df176d77bef6$export$c588cb30ff3b876e);
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $20c6df176d77bef6$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $20c6df176d77bef6$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $20c6df176d77bef6$var$tinyTransparentImage) nativeSetDragImage($20c6df176d77bef6$var$tinyTransparentImage, 0, 0);
}

});


parcelRegister("gZctg", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("ihBqS")).preventUnhandled);

var $ihBqS = parcelRequire("ihBqS");

});
parcelRegister("ihBqS", function(module, exports) {

$parcel$export(module.exports, "preventUnhandled", () => $713d889559578e2f$export$453c0582481cc59d);

var $d8F95 = parcelRequire("d8F95");

var $cmcCB = parcelRequire("cmcCB");
function $713d889559578e2f$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $713d889559578e2f$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $713d889559578e2f$var$start() {
    $713d889559578e2f$var$cleanup();
    $713d889559578e2f$var$unbindEvents = (0, $d8F95.bindAll)(window, [
        {
            type: 'dragover',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $713d889559578e2f$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $713d889559578e2f$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $713d889559578e2f$var$cleanup
        },
        ...(0, $cmcCB.getBindingsForBrokenDrags)({
            onDragEnd: $713d889559578e2f$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $713d889559578e2f$var$cleanup() {
    $713d889559578e2f$var$unbindEvents?.();
    $713d889559578e2f$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $713d889559578e2f$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $713d889559578e2f$var$cleanup();
}
const $713d889559578e2f$export$453c0582481cc59d = {
    start: $713d889559578e2f$var$start,
    stop: $713d889559578e2f$var$stop
};

});


parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::692b62fec4c56cd82ae8d8d02e2d3f2e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("yuLaV", function(module, exports) {

$parcel$export(module.exports, "isContentTypeEnabledInCurrentEnv", () => $705f1ec06aff7fce$export$dd376e644565eb89);

var $lzcvT = parcelRequire("lzcvT");
const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') return !(0, $lzcvT.isFedRamp)();
    return true;
};

});

parcelRegister("fstZx", function(module, exports) {

$parcel$export(module.exports, "StarredSpacesQuery", () => $bb42a67b08b88af0$export$f89460d6594658f1);
$parcel$export(module.exports, "MyVisitedSpacesQuery", () => $bb42a67b08b88af0$export$73b0293722a8eb9f);
$parcel$export(module.exports, "MyVisitedSpacesWithCurrentSpaceQuery", () => $bb42a67b08b88af0$export$9fdae40747d95364);
$parcel$export(module.exports, "AnonymousSpacesQuery", () => $bb42a67b08b88af0$export$2e53cde7a8b8bbee);
$parcel$export(module.exports, "SearchSpacesQuery", () => $bb42a67b08b88af0$export$7c52f7af355ed457);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $bb42a67b08b88af0$export$f89460d6594658f1 = (0, $d2LG0.default)`query StarredSpacesQuery{spaces(favourite:true first:99 status:"current"){nodes{alias id name key icon{path}}}}`;
const $bb42a67b08b88af0$export$73b0293722a8eb9f = (0, $d2LG0.default)`query MyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias id name key icon{path}}}}}`;
const $bb42a67b08b88af0$export$9fdae40747d95364 = (0, $d2LG0.default)`query MyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias id name key icon{path}currentUser{isFavourited}}myVisitedSpaces(limit:26){nodes{spaces{alias id name key icon{path}}}}}`;
const $bb42a67b08b88af0$export$2e53cde7a8b8bbee = (0, $d2LG0.default)`query AnonymousSpacesQuery{spaces(first:10){nodes{alias id name key icon{path}}}}`;
const $bb42a67b08b88af0$export$7c52f7af355ed457 = (0, $d2LG0.default)`query SearchSpacesQuery($spaceNamePattern:String!$isLicensed:Boolean!){spaces(first:30 status:"current" spaceNamePattern:$spaceNamePattern){nodes{alias id name key icon{path}currentUser@include(if:$isLicensed){isFavourited}}}}`;

});

parcelRegister("kpYGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $21366d93ef656d79$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $21366d93ef656d79$var$shimmerKeyframes = null;
const $21366d93ef656d79$var$skeletonStyles = null;
const $21366d93ef656d79$var$activeShimmerStyles = null; /**
                                   * __Skeleton__
                                   *
                                   * A skeleton acts as a placeholder for content, usually while the content loads.
                                   *
                                   * - [Examples](https://atlassian.design/components/skeleton/examples)
                                   * - [Code](https://atlassian.design/components/skeleton/code)
                                   */ 
const $21366d93ef656d79$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $35pXk.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq1y0p"
        ])
    });
};
var $21366d93ef656d79$export$2e2bcd8739ae039 = $21366d93ef656d79$var$Skeleton;

});

parcelRegister("5izcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f788f1551fff696f$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $QiYCb = parcelRequire("QiYCb");

var $6cnUO = parcelRequire("6cnUO");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7UHDa.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;

});
parcelRegister("QiYCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a3edd35791f2369$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dlAOT = parcelRequire("dlAOT");
const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $gwFzn.useRef)(null);
    (0, $gwFzn.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dlAOT))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)("span", {
        ref: divRef,
        className: (0, $35pXk.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;

});


parcelRegister("lsxnT", function(module, exports) {

$parcel$export(module.exports, "useChoreographerAssets", () => $be0f158b0b06806d$export$20bf42c8a29d776a);

var $gwFzn = parcelRequire("gwFzn");

var $cryCi = parcelRequire("cryCi");
const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $gwFzn.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};

});

parcelRegister("8rneB", function(module, exports) {

$parcel$export(module.exports, "getVersionNumber", () => $61659933fe71a4ee$export$d2d37cdca5b73056);
$parcel$export(module.exports, "getEmojiId", () => $61659933fe71a4ee$export$4f65bc4b6ab2638);
$parcel$export(module.exports, "sanitizeEmojiValue", () => $61659933fe71a4ee$export$7f77dde40cb9b60a);
$parcel$export(module.exports, "getEmojiPublishedProperty", () => $61659933fe71a4ee$export$1b37039eb4b94aa5);
$parcel$export(module.exports, "getEmojiDraftProperty", () => $61659933fe71a4ee$export$4d2921b7085d93bb);
$parcel$export(module.exports, "getEmojiFromPublishedPageProperties", () => $61659933fe71a4ee$export$f6641c501f8a1aee);
$parcel$export(module.exports, "getEmojiFromDraftPageProperties", () => $61659933fe71a4ee$export$e1cb12562674727b);
$parcel$export(module.exports, "getPublishedEmojiId", () => $61659933fe71a4ee$export$db0acf1152e62ad6);
$parcel$export(module.exports, "getEmojiValueFromContent", () => $61659933fe71a4ee$export$a5b3ff94c918547);
$parcel$export(module.exports, "getEmojiDraftFromProperties", () => $61659933fe71a4ee$export$bb520a2176fa2873);
$parcel$export(module.exports, "getEmojiPublishedFromProperties", () => $61659933fe71a4ee$export$fbf43d9e87015d93);
$parcel$export(module.exports, "getHasEmoji", () => $61659933fe71a4ee$export$b8852397200defa1);
$parcel$export(module.exports, "getHasEmojiPublished", () => $61659933fe71a4ee$export$53519180ca077ff2);
$parcel$export(module.exports, "getEmojiProvider", () => $61659933fe71a4ee$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getHasLiveDocsDefaultEmoji", () => $61659933fe71a4ee$export$efb819bf9c3235c7);

var $ibzAc = parcelRequire("ibzAc");

var $32x2E = parcelRequire("32x2E");

var $9wGTI = parcelRequire("9wGTI");

var $5amrO = parcelRequire("5amrO");
const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: property?.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.publicLinkInformation || data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    const nodes = (data?.publicLinkInformation || data?.content?.nodes?.[0] || data?.singleContent)?.[emojiFieldName]?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!(0, $9wGTI.fg)('live_pages_default_icon') || !data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};

});
parcelRegister("5amrO", function(module, exports) {

$parcel$export(module.exports, "EMOJI_TITLE_DRAFT_FIELD", () => $bb7cbab4663812b3$export$5a027b13986198b7);
$parcel$export(module.exports, "EMOJI_TITLE_PUBLISHED_FIELD", () => $bb7cbab4663812b3$export$b78a8db8f4546258);
$parcel$export(module.exports, "useEmojiStatusFieldName", () => $bb7cbab4663812b3$export$61509c1d76ea5fb2);
$parcel$export(module.exports, "convertEmojiFieldNameToPropertyKey", () => $bb7cbab4663812b3$export$28c62f1b367f9166);

var $3jwuS = parcelRequire("3jwuS");

var $99t4P = parcelRequire("99t4P");
const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    // whiteboards and live pages are always published, so return EMOJI_TITLE_PUBLISHED_FIELD
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};

});
parcelRegister("99t4P", function(module, exports) {

$parcel$export(module.exports, "isEmojiTitleEnabled", () => $6b4026d31beb25d0$export$f0410e068eb2ef9e);

var $9wGTI = parcelRequire("9wGTI");
const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};

});



parcelRegister("9MhzF", function(module, exports) {

$parcel$export(module.exports, "isValidUrl", () => $df5c51c7bf673d12$export$bef94a5618bf18bf);
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};

});

parcelRegister("bCECL", function(module, exports) {

$parcel$export(module.exports, "ContentIcon", () => $b2e0c504f331f5cc$export$a1ea799cb5c1b499);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $e0ycV = parcelRequire("e0ycV");

var $8jHAi = parcelRequire("8jHAi");

var $9RVmI = parcelRequire("9RVmI");

var $ZDq1z = parcelRequire("ZDq1z");

var $6B0jU = parcelRequire("6B0jU");

var $5tmwS = parcelRequire("5tmwS");

var $cHaKZ = parcelRequire("cHaKZ");

var $9QMji = parcelRequire("9QMji");

var $2JGYp = parcelRequire("2JGYp");

var $gTyTP = parcelRequire("gTyTP");
const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16 })=>{
    const { isTwoPageTypesExperience: isTwoPageTypesExperience } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    const defaultedType = type === 'liveDoc' ? 'page' : type; // Prevent using 'liveDoc' type directly
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9QMji.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: defaultedType,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const definition = isLivePage && isTwoPageTypesExperience ? $b2e0c504f331f5cc$var$iconDefinitions['liveDoc'] : $b2e0c504f331f5cc$var$iconDefinitions[defaultedType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $2nPZH.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHaKZ))),
        label: $b2e0c504f331f5cc$var$i18n.space
    }
};

});
parcelRegister("2JGYp", function(module, exports) {

$parcel$export(module.exports, "isValidEmojiOrFavicon", () => $3f74e24d74be50af$export$2629e776cd65f583);

var $9MhzF = parcelRequire("9MhzF");

var $5dh5C = parcelRequire("5dh5C");

var $8rneB = parcelRequire("8rneB");
const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
	 * Why do emojis need to be 'sanitized'? Originally emoji content properties
	 * (emoji-title-published, emoji-title-draft) were a part of a REST API
	 * where the value would be JSON and not just a string.  This is why emoji
	 * values come through with extra quotes and we have to clean that up.
	 * A URL with quotes is not a valid URL.
	 * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
	 * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
	 */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};

});
parcelRegister("5dh5C", function(module, exports) {

$parcel$export(module.exports, "isValidEmoji", () => $e57f5fd4620d2578$export$122aed4aa2d0ca26);
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};

});



parcelRegister("gfIPU", function(module, exports) {

$parcel$export(module.exports, "ExperienceFailure", () => $5675860ef242c9e4$export$eed1d73ebdd8c7ab);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $5675860ef242c9e4$export$eed1d73ebdd8c7ab({ name: name, error: error, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.fail({
            name: name,
            error: error,
            attributes: attributes
        }), [
        experienceTracker,
        name,
        error,
        attributes
    ]);
    return null;
}

});

parcelRegister("1eaCJ", function(module, exports) {

$parcel$export(module.exports, "ExperienceSuccess", () => $03574d8c2683228e$export$4962f3898bd5c829);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $03574d8c2683228e$export$4962f3898bd5c829({ name: name, attributes: attributes }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>experienceTracker.succeed({
            name: name,
            attributes: attributes
        }), [
        name,
        attributes,
        experienceTracker
    ]);
    return null;
}

});

parcelRegister("kAcNG", function(module, exports) {

$parcel$export(module.exports, "useSitePersonalizationQuery", () => $a3e54b7319a42934$export$3cfde1d6c626a865);

var $j1Ss3 = parcelRequire("j1Ss3");

var $8Lx5S = parcelRequire("8Lx5S");

var $dIouf = parcelRequire("dIouf");

var $g2lhM = parcelRequire("g2lhM");
let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $g2lhM.SitePersonalizationQuery), {
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $dIouf.isStatusCodeError)(graphQLError, '401') || (0, $dIouf.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};

});
parcelRegister("g2lhM", function(module, exports) {

$parcel$export(module.exports, "SitePersonalizationQuery", () => $ce3ee7feeac4bdd4$export$f103a917673d8e03);

var $d2LG0 = parcelRequire("d2LG0");
const $ce3ee7feeac4bdd4$export$f103a917673d8e03 = (0, $d2LG0.default)`query SitePersonalizationQuery($cloudId:String!)@experimental{experimentalSitePersonalization(cloudId:$cloudId){attributes{name value}}}`;

});


parcelRegister("2FNNv", function(module, exports) {

$parcel$export(module.exports, "useIsEstablishedUserTraitName", () => $f30477d177bb95bd$export$a284916a4d5ed017);

var $bQm3c = parcelRequire("bQm3c");
// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};

});

parcelRegister("8VGt1", function(module, exports) {

$parcel$export(module.exports, "LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS", () => $3f8738dcace09e57$export$9b7b03214c03f17d);
const $3f8738dcace09e57$export$9b7b03214c03f17d = {
    hasDismissedIntroSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedIntroSpotlight',
    hasDismissedLiveDocTour: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocTour',
    hasDismissedLiveDocModal: 'onboarding-live-doc-changeboarding:hasDismissedLiveDocModal',
    hasDismissedContentWrapperTour: 'onboarding-live-doc-changeboarding:hasDismissedContentWrapperTour',
    hasDismissedAiButtonTour: 'onboarding-live-doc-changeboarding:hasDismissedAiButtonTour',
    hasDismissedConvertToPageSpotlight: 'onboarding-live-doc-changeboarding:hasDismissedConvertToPageSpotlight'
};

});

parcelRegister("3J7nf", function(module, exports) {

$parcel$export(module.exports, "isLiveDocChangeboardingActive", () => $575144cb3db51cc4$export$a26d1635f48253f6);
$parcel$export(module.exports, "useLiveDocChangeboarding", () => $575144cb3db51cc4$export$bea8fd520e488fdb);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $ivb8S = parcelRequire("ivb8S");

var $gTyTP = parcelRequire("gTyTP");

var $3jwuS = parcelRequire("3jwuS");

var $aWwYt = parcelRequire("aWwYt");

var $bQm3c = parcelRequire("bQm3c");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $1zBOs = parcelRequire("1zBOs");

var $8VGt1 = parcelRequire("8VGt1");

var $cgSxj = parcelRequire("cgSxj");

var $irr7I = parcelRequire("irr7I");
const $575144cb3db51cc4$export$7e64b0f7c7042443 = {
    introSpotlight: {
        isVisible: false,
        complete: ()=>{}
    },
    liveDocTour: {
        isVisible: false,
        complete: ()=>{}
    },
    contentWrapperTour: {
        isVisible: false,
        complete: ()=>{}
    },
    aiButtonTour: {
        isVisible: false,
        complete: ()=>{}
    }
};
const $575144cb3db51cc4$var$IS_ON_SPACE_OVERVIEW_ROUTES_ARGS = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $575144cb3db51cc4$export$a26d1635f48253f6 = (changeboarding)=>Object.values(changeboarding).some((tour)=>{
        if (typeof tour === 'object' && tour !== null && 'isVisible' in tour) return tour.isVisible;
        return false;
    });
const $575144cb3db51cc4$export$bea8fd520e488fdb = ()=>{
    const [introSpotlightDismissed, setIntroSpotlightDismissed] = (0, $gwFzn.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { isEstablishedUser: isEstablishedUser, loading: isEstablishedUserLoading, error: isEstablishedUserError } = (0, $1zBOs.useIsEstablishedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap') && !(0, $9wGTI.fg)('confluence_frontend_object_sidebar_changeboarding') && !(0, $9wGTI.fg)('confluence_ai_uber_button_changeboarding')
    });
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $8VGt1.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap') && !(0, $9wGTI.fg)('confluence_frontend_object_sidebar_changeboarding') && !(0, $9wGTI.fg)('confluence_ai_uber_button_changeboarding'));
    const { hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasDismissedContentWrapperTour: hasDismissedContentWrapperTour, hasDismissedAiButtonTour: hasDismissedAiButtonTour } = (0, $ivb8S.deserializeState)(data);
    const { isTwoPageTypesExperience: isTwoPageTypesExperience } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePagesAvailableInSpace = (0, $cgSxj.useIsLivePagesAvailableInSpace)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { sidebarControlState: sidebarControlState } = (0, $aWwYt.useObjectSidebarState)();
    const isContentWrapperVisible = sidebarControlState === 'shown';
    const isOnSpaceOverviewRoute = (0, $dPJCf.useRouteName)($575144cb3db51cc4$var$IS_ON_SPACE_OVERVIEW_ROUTES_ARGS);
    const isAiButtonVisible = isContentWrapperVisible && isAdminHubAIEnabled && (isLivePage ? (0, $9wGTI.fg)('confluence_ai_uber_button_in_live_pages') : (0, $9wGTI.fg)('confluence_ai_uber_button_in_object_sidebar'));
    const introSpotlightBaseCase = !introSpotlightDismissed && isTwoPageTypesExperience && !hasDismissedLiveDocTour && !hasDismissedIntroSpotlight && isLivePagesAvailableInSpace && !isLivePage;
    const showIntroSpotlight = introSpotlightBaseCase && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap');
    const showGAIntroSpotlight = introSpotlightBaseCase && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding');
    const showLiveDocTour = isLivePage && isTwoPageTypesExperience && !hasDismissedLiveDocTour && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap');
    const showContentWrapperTour = !isLivePage && !isOnSpaceOverviewRoute && isContentWrapperVisible && !hasDismissedContentWrapperTour && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('confluence_frontend_object_sidebar_changeboarding');
    const showAiButtonTour = !isLivePage && !isOnSpaceOverviewRoute && isAiButtonVisible && !hasDismissedAiButtonTour && (0, $9wGTI.fg)('confluence_ai_uber_button_changeboarding');
    const { isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding, isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding, loading: nav4Loading, error: nav4Error } = (0, $irr7I.useIsNav4Changeboarding)();
    const completeIntroSpotlight = (0, $gwFzn.useCallback)(()=>{
        setIntroSpotlightDismissed(true);
        setOnboardingState({
            key: (0, $8VGt1.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedIntroSpotlight,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $8VGt1.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeContentWrapperTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $8VGt1.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedContentWrapperTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeAiButtonTour = (0, $gwFzn.useCallback)(()=>{
        setOnboardingState({
            key: (0, $8VGt1.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedAiButtonTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    // Skip onboarding for new users if features are enabled, by marking eligible onboarding as complete.
    // If we did not check to see if they were eligible for each onboarding before marking it complete,
    // we would risk marking onboarding complete when the feature is not yet enabled.
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return;
        if (error || loading || isEstablishedUserError || isEstablishedUserLoading) return;
        if (!isEstablishedUser) {
            if (showIntroSpotlight) completeIntroSpotlight();
            if (showLiveDocTour) completeLiveDocTour();
            if (showContentWrapperTour) completeContentWrapperTour();
            if (showAiButtonTour) completeAiButtonTour();
        }
    }, [
        isEstablishedUser,
        showIntroSpotlight,
        showLiveDocTour,
        showContentWrapperTour,
        showAiButtonTour,
        completeAiButtonTour,
        completeContentWrapperTour,
        completeIntroSpotlight,
        completeLiveDocTour,
        error,
        isEstablishedUserError,
        isEstablishedUserLoading,
        loading
    ]);
    if (error || nav4Error) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        error: error || nav4Error
    };
    if (loading || nav4Loading || isEstablishedUserLoading) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        loading: true
    };
    if (showGAIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    // Do not start Live Doc changeboarding until eligible user has completed nav4 changeboarding
    if (isUserEnrolledInNav4Changeboarding && !isUserCompletedNav4Changeboarding) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (!isEstablishedUser) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (showLiveDocTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        liveDocTour: {
            isVisible: true,
            complete: completeLiveDocTour
        }
    };
    if (showContentWrapperTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        contentWrapperTour: {
            isVisible: true,
            complete: completeContentWrapperTour
        }
    };
    if (showAiButtonTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        aiButtonTour: {
            isVisible: true,
            complete: completeAiButtonTour
        }
    };
    if (showIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    return $575144cb3db51cc4$export$7e64b0f7c7042443;
};

});
parcelRegister("aWwYt", function(module, exports) {

$parcel$export(module.exports, "MIN_PANEL_WIDTH", () => $5371993c50b87836$export$9e0a6941e0e87c97);
$parcel$export(module.exports, "useObjectSidebarActions", () => $5371993c50b87836$export$332594c77a860a26);
$parcel$export(module.exports, "useObjectSidebarState", () => $5371993c50b87836$export$41c5dcc793387db5);
$parcel$export(module.exports, "useIsObjectSidebarShown", () => $5371993c50b87836$export$a572d51222d5ea45);
$parcel$export(module.exports, "usePanel", () => $5371993c50b87836$export$9168a42f32e3d071);
$parcel$export(module.exports, "useBehavior", () => $5371993c50b87836$export$8b43142d6fd506da);
$parcel$export(module.exports, "useIsPanelScrolled", () => $5371993c50b87836$export$ec8631e69ae8c803);
$parcel$export(module.exports, "usePanelWidth", () => $5371993c50b87836$export$82b270f291af5a5);
$parcel$export(module.exports, "useUpdatedHeaderComponentElements", () => $5371993c50b87836$export$bc4f8f2fe52e3d40);
$parcel$export(module.exports, "useSidebarControlState", () => $5371993c50b87836$export$d4d7180dad517777);
$parcel$export(module.exports, "useSidebarControlExpandCollapsedState", () => $5371993c50b87836$export$b00fb66a9723fc58);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $8gtQ7 = parcelRequire("8gtQ7");

var $9wGTI = parcelRequire("9wGTI");
const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed'
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            setState({
                panelWidth: Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97) + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $4ZoIm.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $iFWZA.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $8gtQ7.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $gwFzn.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = (0, $gwFzn.useMemo)(()=>(0, $9wGTI.fg)('confluence_preview_panels') ? showObjectSidebarWrapper : internalActions.showObjectSidebar, [
        showObjectSidebarWrapper,
        internalActions.showObjectSidebar
    ]);
    const memoizedActions = (0, $gwFzn.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $gwFzn.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $iFWZA.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});

});
parcelRegister("8gtQ7", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelsActions", () => $1e5215e1f439a288$export$5f5debba1692bf40);

var $gwFzn = parcelRequire("gwFzn");

var $2QMNQ = parcelRequire("2QMNQ");
const $1e5215e1f439a288$export$5f5debba1692bf40 = ()=>{
    const context = (0, $2QMNQ.usePreviewPanelsContext)();
    const dispatch = context?.dispatch;
    const setPanelWidth = (0, $gwFzn.useCallback)((width)=>{
        dispatch?.({
            type: 'SET_PANEL_WIDTH',
            width: width
        });
    }, [
        dispatch
    ]);
    const close = (0, $gwFzn.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
    }, [
        dispatch
    ]);
    const open = (0, $gwFzn.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
    }, [
        dispatch
    ]);
    return {
        setPanelWidth: setPanelWidth,
        close: close,
        open: open
    };
};

});
parcelRegister("2QMNQ", function(module, exports) {

$parcel$export(module.exports, "PreviewPanelsProvider", () => $0fe21c36979e0689$export$65ae37e9c61321f9);
$parcel$export(module.exports, "usePreviewPanelsContext", () => $0fe21c36979e0689$export$609db4be92d0fad8);
$parcel$export(module.exports, "useIsPreviewPanelOpen", () => $0fe21c36979e0689$export$c68e55e6e77f3d5d);
$parcel$export(module.exports, "useCurrentPreviewPanel", () => $0fe21c36979e0689$export$5351114e92b31bc6);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $iJRU1 = parcelRequire("iJRU1");
const $0fe21c36979e0689$export$f473d225913e225d = /*#__PURE__*/ (0, $gwFzn.createContext)(undefined);
const $0fe21c36979e0689$export$35041b83145053c1 = (state, action)=>{
    switch(action.type){
        case 'SET_PANEL_WIDTH':
            return {
                ...state,
                width: action.width
            };
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.closePanelSlot?.();
            return 0, $iJRU1.initialState;
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel.id === params.panel.id) return state;
            // Close the active panel.
            state.onClose();
            state.closePanelSlot?.();
            // Open the new panel.
            state.openPanelSlot?.();
            params.onOpen?.();
            return {
                ...state,
                panel: params.panel,
                width: params.width || (0, $iJRU1.initialState).width,
                onOpen: params.onOpen || (0, $iJRU1.initialState).onOpen,
                onClose: params.onClose || (0, $iJRU1.initialState).onClose
            };
        default:
            return state;
    }
};
const $0fe21c36979e0689$export$65ae37e9c61321f9 = ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, children: children })=>{
    (0, $iJRU1.initialState).closePanelSlot = onPreviewPanelClose;
    (0, $iJRU1.initialState).openPanelSlot = onPreviewPanelOpen;
    const [state, dispatch] = (0, $gwFzn.useReducer)($0fe21c36979e0689$export$35041b83145053c1, (0, $iJRU1.initialState));
    const context = (0, $gwFzn.useMemo)(()=>({
            state: state,
            dispatch: dispatch
        }), [
        state,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)($0fe21c36979e0689$export$f473d225913e225d.Provider, {
        value: context,
        children: children
    });
};
const $0fe21c36979e0689$export$609db4be92d0fad8 = ()=>{
    const context = (0, $gwFzn.useContext)($0fe21c36979e0689$export$f473d225913e225d);
    return context;
};
const $0fe21c36979e0689$export$c68e55e6e77f3d5d = (panelId)=>{
    const context = $0fe21c36979e0689$export$609db4be92d0fad8();
    return panelId ? context?.state.panel.id === panelId : !!context?.state.panel.id;
};
const $0fe21c36979e0689$export$5351114e92b31bc6 = ()=>{
    const context = $0fe21c36979e0689$export$609db4be92d0fad8();
    return context?.state.panel ?? (0, $iJRU1.initialState).panel;
};

});
parcelRegister("iJRU1", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $85f43b535c1c3f9c$export$d4c72bab9d6cc13a);
const $85f43b535c1c3f9c$export$d4c72bab9d6cc13a = {
    // Configured by the product to allow for nuances in how the
    // product handles opening and closing of the preview panel.
    closePanelSlot: ()=>{},
    openPanelSlot: ()=>{},
    // Configured when opening a panel.
    panel: {
        id: '',
        content: undefined
    },
    width: 400,
    onOpen: ()=>{},
    onClose: ()=>{}
};

});




parcelRegister("1zBOs", function(module, exports) {

$parcel$export(module.exports, "useIsEstablishedUser", () => $e4b48658f7bfd739$export$fbded7f0a0c86e5e);

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $bQm3c = parcelRequire("bQm3c");

var $2FNNv = parcelRequire("2FNNv");
const $e4b48658f7bfd739$var$UseIsEstablishedUserUserPersonalizationQuery = (0, $d2LG0.default)`query useIsEstablishedUserUserPersonalizationQuery($userId:String!)@experimental{experimentalUserPersonalization(userId:$userId){attributes{name value}}}`;
const $e4b48658f7bfd739$export$fbded7f0a0c86e5e = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($e4b48658f7bfd739$var$UseIsEstablishedUserUserPersonalizationQuery, {
        skip: skip || !userId,
        variables: {
            userId: userId
        }
    });
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const isEstablishedUser = Boolean(data?.experimentalUserPersonalization?.attributes?.some(({ name: name, value: value })=>name === isEstablishedUserTraitName && value === 'true'));
    return {
        isEstablishedUser: isEstablishedUser,
        loading: loading,
        error: error
    };
};

});

parcelRegister("cgSxj", function(module, exports) {

$parcel$export(module.exports, "useIsLivePagesAvailableInSpace", () => $3ddccd966453cb80$export$6dd95cedb3ff0cda);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $ep3mz = parcelRequire("ep3mz");

var $lH4kr = parcelRequire("lH4kr");
const $3ddccd966453cb80$export$6dd95cedb3ff0cda = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: defaultSpaceKeyData } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $lH4kr.GetDefaultSpaceQuery), {
        skip: spaceKey !== undefined
    });
    const { data: enabledContentTypesData } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query useIsLivePagesAvailableInSpaceSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`, {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    });
    return enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled : false;
};

});
parcelRegister("lH4kr", function(module, exports) {

$parcel$export(module.exports, "GetDefaultSpaceQuery", () => $92197877dc21efb5$export$9d480e5fa307b726);

var $d2LG0 = parcelRequire("d2LG0");
const $92197877dc21efb5$export$9d480e5fa307b726 = (0, $d2LG0.default)`query GetDefaultSpaceQuery($promotedSpaceKey:String)@experimental{experimentalPromotedSpaces(promotedSpacesLimit:1 otherSpacesLimit:1 promotedSpaceKey:$promotedSpaceKey){nodes{id}}}`;

});


parcelRegister("irr7I", function(module, exports) {

$parcel$export(module.exports, "useIsNav4Changeboarding", () => $e18371ec7eace185$export$67ed1464307296e4);

var $j1Ss3 = parcelRequire("j1Ss3");

var $d2LG0 = parcelRequire("d2LG0");

var $gz8ZY = parcelRequire("gz8ZY");

var $bQm3c = parcelRequire("bQm3c");
const $e18371ec7eace185$var$Nav4ChangeboardingQuery = (0, $d2LG0.default)`query useIsNav4ChangeboardingQuery($cloudId:String!$userId:String!)@experimental{experimentalSiteUserPersonalization(cloudId:$cloudId userId:$userId){attributes{name value}}}`;
const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT = 'segment_confluence_nav_4_changeboarding_cloned_siteuser';
const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT = 'completed_cc-nav-4-changeboarding-prod';
const $e18371ec7eace185$export$67ed1464307296e4 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)($e18371ec7eace185$var$Nav4ChangeboardingQuery, {
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !isNav4Enabled
    });
    if (!isNav4Enabled) return {
        isUserEnrolledInNav4Changeboarding: false,
        isUserCompletedNav4Changeboarding: false
    };
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    const isUserEnrolledInNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT && value === 'true'));
    const isUserCompletedNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT && !!value));
    return {
        isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding,
        isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding,
        loading: loading,
        error: error
    };
};

});


parcelRegister("cLo2u", function(module, exports) {

$parcel$export(module.exports, "useSpaceKey", () => $91bacb73ef37142f$export$12ed3d1363567203);

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $7zgzO = parcelRequire("7zgzO");
function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    // Space-level data is used to retrieve information about a space's external collaborators
    // in multiple places across the package. Attempt to get spaceKey from a range of sources.
    // If we are in a view-page context, spaceKey data may be available from PageState.
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    // Otherwise, RoutesContext may contain the information we need
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    // Now that our context hooks have executed, we can return if we have a match.
    // Return statements are separated out for optimum readability.
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    // Legacy server-rendered UI pages do not have the "match" object in RoutesContext, but
    // they can contain space information in the <meta> data tag.
    const documentMetaSpaceKey = typeof document !== 'undefined' ? document.querySelector('meta#confluence-space-key')?.content : null;
    return documentMetaSpaceKey ?? null;
}

});

parcelRegister("ln0hx", function(module, exports) {

$parcel$export(module.exports, "ExperienceStart", () => $0c8ceb2bfbb43f95$export$f20b867e738a222c);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $gwFzn.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}

});

parcelRegister("hK4Zq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceaa9a687fcb2ce1$export$2e2bcd8739ae039);

var $7IxPz = parcelRequire("7IxPz");

var $4YLNd = parcelRequire("4YLNd");

var $6Z3KL = parcelRequire("6Z3KL");
function $ceaa9a687fcb2ce1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6Z3KL.default)(2, arguments);
    var date = (0, $4YLNd.default)(dirtyDate);
    var amount = (0, $7IxPz.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("kDja4", function(module, exports) {

$parcel$export(module.exports, "useIsWhiteboardFeatureEnabled", () => $9cbb170f29556407$export$6f83cfa4fd660300);

var $gwFzn = parcelRequire("gwFzn");

var $dh538 = parcelRequire("dh538");

var $9wGTI = parcelRequire("9wGTI");

var $yuLaV = parcelRequire("yuLaV");

var $jf9LK = parcelRequire("jf9LK");
// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $gwFzn.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        if (featureName in (0, (/*@__PURE__*/$parcel$interopDefault($jf9LK)))) {
            const activeFeatureGate = featureName;
            switch(activeFeatureGate){
                case 'whiteboardSolidHeader':
                    return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
                case 'whiteboardOptOut':
                    return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
                case 'aiSmartButton':
                    return (0, $9wGTI.fg)('ai-smart-button-team-25');
                case 'digitalTeammate':
                    return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
                default:
                    throw new Error('unable to find feature gate in whiteboard-feature-gates.json');
            }
        }
        return false;
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $gwFzn.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $gwFzn.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};

});
parcelRegister("jf9LK", function(module, exports) {
module.exports = JSON.parse("{\"whiteboardSolidHeader\":\"confluence_frontend_solid_whiteboard_header\",\"whiteboardOptOut\":\"whiteboards_compliance_opt_out\",\"aiSmartButton\":\"ai-smart-button-team-25\",\"digitalTeammate\":\"cc-ai-whiteboards-enable-digital-teammate\"}");

});


parcelRegister("hXDOc", function(module, exports) {

$parcel$export(module.exports, "HoverPreloader", () => $b22e252a6b9677fd$export$16d0fec7f7c7ddfa);
$parcel$export(module.exports, "HoverPreloaderWithGate", () => $b22e252a6b9677fd$export$d735df49e55d6594);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ children: children, preloadUrl: preloadUrl, onlyJS: onlyJS })=>{
    const hoverTimeoutRef = (0, $gwFzn.useRef)(null);
    const onHover = (0, $gwFzn.useCallback)(()=>{
        window.dispatchEvent(new CustomEvent('preloadOnHover', {
            bubbles: true,
            detail: {
                preloadUrl: preloadUrl,
                onlyJS: onlyJS
            }
        }));
    }, [
        preloadUrl,
        onlyJS
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Median user reaction time (from hover to click) is ~250 ms for small elements such as page tree item.
    // Hence for JS only we don't want to wait for the hover timeout and preload components immediately.
    const preloadTimeout = onlyJS ? 0 : $b22e252a6b9677fd$var$PRELOAD_TIMER;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "hover-preloader",
        onMouseEnter: ()=>{
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = window.setTimeout(()=>{
                onHover();
            }, preloadTimeout);
        },
        onMouseLeave: ()=>{
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        }
    }, children));
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$d735df49e55d6594 = (props)=>{
    if (!props.preloadUrl || !(0, $9wGTI.fg)('confluence_preload_js_hover')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};

});

parcelRegister("4NX9d", function(module, exports) {

$parcel$export(module.exports, "PerformanceEnd", () => $6182ff2f7ce21920$export$c7a09306845216e0);

var $fppBw = parcelRequire("fppBw");

var $gwFzn = parcelRequire("gwFzn");

var $9eE57 = parcelRequire("9eE57");
class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $gwFzn.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};

});

parcelRegister("O7CpO", function(module, exports) {

$parcel$export(module.exports, "useEditSource", () => $2b28d3953e9e81ba$export$ee479a8e5902b302);
$parcel$export(module.exports, "useEditSourceActions", () => $2b28d3953e9e81ba$export$7e972f51583fdb8e);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $2b28d3953e9e81ba$export$64697004958d0ff1 = {
    editSource: ''
};
const $2b28d3953e9e81ba$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        ...$2b28d3953e9e81ba$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $2b28d3953e9e81ba$export$ee479a8e5902b302 = (0, $iFWZA.createHook)($2b28d3953e9e81ba$var$Store);
const $2b28d3953e9e81ba$export$7e972f51583fdb8e = (0, $iFWZA.createActionsHook)($2b28d3953e9e81ba$var$Store);

});

parcelRegister("jKIuI", function(module, exports) {

$parcel$export(module.exports, "PAGE_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$45d9f22b250b4fa6);
$parcel$export(module.exports, "BLOG_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$daadd9484abf9243);
$parcel$export(module.exports, "SPACE_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$18ec89b444ed9e13);
$parcel$export(module.exports, "PAGE_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$1670e1f700b91982);
$parcel$export(module.exports, "BLOG_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$99c4be058cda9518);
$parcel$export(module.exports, "SPACE_EDIT_SHORTCUT_E", () => $51c3cbbb1947581f$export$9a65fbf92be78751);
$parcel$export(module.exports, "PAGECARD_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$835a97ed77363e2a);
$parcel$export(module.exports, "QUICK_ACTIONS_EDIT_BUTTON_CLICK", () => $51c3cbbb1947581f$export$aca8dbff71ee152b);
$parcel$export(module.exports, "CREATE_PAGE_SHORTCUT", () => $51c3cbbb1947581f$export$62ca21e37a92c063);
$parcel$export(module.exports, "CREATE_NAV_BUTTON_CLICK", () => $51c3cbbb1947581f$export$6eda3121bad7aadf);
$parcel$export(module.exports, "CREATE_PAGETREE_BLOG_BUTTON_CLICK", () => $51c3cbbb1947581f$export$7698b0f9c7cef133);
$parcel$export(module.exports, "CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK", () => $51c3cbbb1947581f$export$d83b4b43e279cde5);
$parcel$export(module.exports, "CREATE_PAGETREE_PAGE_BUTTON_CLICK", () => $51c3cbbb1947581f$export$1dd5c358458f3c8f);
$parcel$export(module.exports, "InitialLoadEditSources", () => $51c3cbbb1947581f$export$6e88709afea7d3ed);
//Add entry points here and import only your entry point to support treeshaking
const $51c3cbbb1947581f$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $51c3cbbb1947581f$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $51c3cbbb1947581f$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $51c3cbbb1947581f$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $51c3cbbb1947581f$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $51c3cbbb1947581f$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $51c3cbbb1947581f$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $51c3cbbb1947581f$export$6e88709afea7d3ed = [
    $51c3cbbb1947581f$export$aca8dbff71ee152b,
    $51c3cbbb1947581f$export$835a97ed77363e2a,
    $51c3cbbb1947581f$export$d8133449fbfd82d4,
    $51c3cbbb1947581f$export$a5c6eb91dd72e7c0
];

});

parcelRegister("iKskQ", function(module, exports) {

$parcel$export(module.exports, "SpaceIcon", () => $b378bfc9d198c46c$export$38ffce4a7986ba20);
/* SpaceIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $buthI = parcelRequire("buthI");

var $4wwVl = parcelRequire("4wwVl");
const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkn82g",
    loaded: "_bfhk18uv"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko1y44 _1bsbgktf _4t3igktf",
    small: "_2rkoyh40 _1bsb1tcg _4t3i1tcg",
    medium: "_2rko1l7b _1bsbzwfg _4t3izwfg",
    large: "_2rko1l7b _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rkoi2wt _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($4wwVl)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $gwFzn.memo)(({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $gwFzn.useState)(!src);
    const setLoaded = (0, $gwFzn.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $35pXk.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($buthI)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
        label: label,
        testId: testId
    });
});

});

parcelRegister("9YFMJ", function(module, exports) {

$parcel$export(module.exports, "usePreviewPanelWidth", () => $f18f6706c6f617ef$export$11aebac00391a86c);

var $2QMNQ = parcelRequire("2QMNQ");
const $f18f6706c6f617ef$export$11aebac00391a86c = ()=>{
    const context = (0, $2QMNQ.usePreviewPanelsContext)();
    const emptyWidth = {
        width: undefined
    };
    if (!context) return emptyWidth;
    const { state: { width: width, panel: { content: content } } } = context;
    if (!content) return emptyWidth;
    return {
        width: width
    };
};

});

parcelRegister("aWrnw", function(module, exports) {

$parcel$export(module.exports, "SPACE_NAVIGATION_METRIC", () => $d4615ab6ca7803f7$export$b9931e60e47a0122);
$parcel$export(module.exports, "SPACE_APPS_METRIC", () => $d4615ab6ca7803f7$export$618f453a5683e37b);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");

var $1Hqbt = parcelRequire("1Hqbt");
const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});

});
parcelRegister("1Hqbt", function(module, exports) {

$parcel$export(module.exports, "ssrConfig", () => $a75b16828791e7fd$export$ea92d4e542ec02b3);
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined;

});


parcelRegister("cvtof", function(module, exports) {

$parcel$export(module.exports, "SideNavVisibilityState", () => $6e62a89b3ae4c955$export$eb04201bb6dd1e4e);
$parcel$export(module.exports, "SetSideNavVisibilityState", () => $6e62a89b3ae4c955$export$f6b496b07d1ea493);

var $gwFzn = parcelRequire("gwFzn");

var $ee7An = parcelRequire("ee7An");
const $6e62a89b3ae4c955$export$eb04201bb6dd1e4e = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $6e62a89b3ae4c955$export$f6b496b07d1ea493 = /*#__PURE__*/ (0, $gwFzn.createContext)((0, $ee7An.default));

});

parcelRegister("dVkip", function(module, exports) {

$parcel$export(module.exports, "useStarredData", () => $568e72a32d90ae8c$export$e3e9588fd2c1abdd);
$parcel$export(module.exports, "useSpacesData", () => $568e72a32d90ae8c$export$680b01e9499af50d);
$parcel$export(module.exports, "useSpaceSearchData", () => $568e72a32d90ae8c$export$ecaaf759b72f2f3d);

var $j1Ss3 = parcelRequire("j1Ss3");

var $gwFzn = parcelRequire("gwFzn");

var $ep3mz = parcelRequire("ep3mz");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $fstZx = parcelRequire("fstZx");
const $568e72a32d90ae8c$var$hasCurrentSpace = (data)=>'space' in data;
const $568e72a32d90ae8c$var$isCurrentSpaceNotFoundError = (gqlError)=>gqlError.path?.[0] === 'space' && gqlError.extensions?.['statusCode'] === 404;
const $568e72a32d90ae8c$var$processStarredError = (error)=>{
    if (!error) return undefined;
    if ((0, $dIouf.isUnauthorizedError)(error)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$var$processRecentError = (error)=>{
    if (!error) return undefined;
    /**
	 * space
	 *    403: Expected to occur when the user is on a restricted space
	 *    404: Expected to occur when the user is on an invalid space
	 * recentSpaces
	 *    403: Harmless error temporarily being ignored to mitigate CONFDEV-71458.
	 *         Removing in CONFDEV-71656.
	 */ if ((0, $dIouf.isUnauthorizedError)(error) || !error.networkError && error.graphQLErrors.every($568e72a32d90ae8c$var$isCurrentSpaceNotFoundError)) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
    return error;
};
const $568e72a32d90ae8c$export$e3e9588fd2c1abdd = (isLicensed)=>{
    const query = isLicensed ? (0, $fstZx.StarredSpacesQuery) : (0, $fstZx.AnonymousSpacesQuery);
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(query, {
        variables: {}
    });
    const starredSpaces = (data?.spaces?.nodes || []).filter((space)=>space != null).map((space)=>({
            ...space,
            currentUser: {
                isFavourited: isLicensed
            }
        }));
    const unexpectedError = $568e72a32d90ae8c$var$processStarredError(error);
    return {
        starredSpaces: starredSpaces,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$var$useRecentData = (isLicensed)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const VisitedQuery = spaceKey ? (0, $fstZx.MyVisitedSpacesWithCurrentSpaceQuery) : (0, $fstZx.MyVisitedSpacesQuery);
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(VisitedQuery, {
        skip: !isLicensed,
        variables: {
            selectedSpaceKey: spaceKey
        },
        errorPolicy: 'all'
    });
    const currentSpace = data && $568e72a32d90ae8c$var$hasCurrentSpace(data) && data.space || undefined;
    const recentData = data?.myVisitedSpaces?.nodes?.spaces;
    const recentSpaces = (recentData || []).filter((space)=>space != null && (!currentSpace || currentSpace.id !== space.id));
    const unexpectedError = $568e72a32d90ae8c$var$processRecentError(error);
    return {
        recentSpaces: recentSpaces,
        currentSpace: currentSpace,
        loading: loading,
        error: unexpectedError
    };
};
const $568e72a32d90ae8c$export$680b01e9499af50d = ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { starredSpaces: starredSpaces, loading: starredLoading, error: starredError } = $568e72a32d90ae8c$export$e3e9588fd2c1abdd(isLicensed);
    const { recentSpaces: unfilteredRecents, currentSpace: currentSpace, loading: recentLoading, error: recentError } = $568e72a32d90ae8c$var$useRecentData(isLicensed);
    const starredIds = new Set(starredSpaces.map((starred)=>starred.id));
    const recentSpaces = unfilteredRecents.filter((recent)=>!starredIds.has(recent.id)).slice(0, 5);
    const errors = [];
    if (starredError) errors.push(starredError);
    if (recentError) errors.push(recentError);
    return {
        errors: errors,
        loading: starredLoading || recentLoading,
        starredSpaces: starredSpaces,
        recentSpaces: recentSpaces,
        currentSpace: currentSpace
    };
};
const $568e72a32d90ae8c$export$ecaaf759b72f2f3d = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const [executeSearch, { data: data, loading: loading, error: error }] = (0, $j1Ss3.useLazyQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fstZx.SearchSpacesQuery));
    const spaceSearchResults = (data?.spaces?.nodes || []).filter((space)=>space != null);
    const searchSpaces = (0, $gwFzn.useCallback)((pattern)=>{
        if (pattern) executeSearch({
            variables: {
                spaceNamePattern: pattern,
                isLicensed: isLicensed
            }
        });
    }, [
        executeSearch,
        isLicensed
    ]);
    return {
        spaceSearchResults: spaceSearchResults,
        loading: loading,
        error: error,
        searchSpaces: searchSpaces
    };
};

});

parcelRegister("2KDGn", function(module, exports) {

$parcel$export(module.exports, "MenuSection", () => $638cfbabdda0ec1b$export$4b1545b4f2016d26);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $c0qxy = parcelRequire("c0qxy");

var $jjpBv = parcelRequire("jjpBv");

var $8ihP4 = parcelRequire("8ihP4");
const $638cfbabdda0ec1b$export$4b1545b4f2016d26 = ({ children: children, testId: testId, isMenuListItem: isMenuListItem = false })=>{
    const id = (0, $c0qxy.useId)();
    const content = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8ihP4.MenuSectionContext).Provider, {
        value: id,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            role: "group",
            "aria-labelledby": `${id}-heading`,
            children: children
        })
    });
    if (isMenuListItem) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $jjpBv.MenuListItem), {
        testId: testId,
        children: content
    });
    // Legacy. isMenuListItem should become default.
    return content;
};

});
parcelRegister("8ihP4", function(module, exports) {

$parcel$export(module.exports, "MenuSectionContext", () => $4730c52802594cee$export$728ac99b9c7eea8a);
$parcel$export(module.exports, "useMenuSectionContext", () => $4730c52802594cee$export$8100cda602411810);

var $gwFzn = parcelRequire("gwFzn");

var $5Uzw3 = parcelRequire("5Uzw3");
const $4730c52802594cee$export$728ac99b9c7eea8a = /*#__PURE__*/ (0, $gwFzn.createContext)(null);
const $4730c52802594cee$export$8100cda602411810 = ()=>{
    const context = (0, $gwFzn.useContext)($4730c52802594cee$export$728ac99b9c7eea8a);
    (0, $5Uzw3.default)(context, 'useMenuSectionContext must be used within a MenuSection');
    return context;
};

});


parcelRegister("2bhek", function(module, exports) {

$parcel$export(module.exports, "MenuSectionHeading", () => $05040ae100858c36$export$5d3acdbf9237a364);
/* menu-section-heading.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $8ihP4 = parcelRequire("8ihP4");
const $05040ae100858c36$var$styles = {
    root: "_11c81vhk _1rjcu2gc _syaz131l _bozg12x7"
}; /**
    * __MenuSectionHeading__
    *
    * The label for the menu section group.
    */ 
const $05040ae100858c36$export$5d3acdbf9237a364 = ({ children: children })=>{
    const id = (0, $8ihP4.useMenuSectionContext)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)("h2", {
        id: `${id}-heading`,
        className: (0, $35pXk.default)([
            $05040ae100858c36$var$styles.root
        ]),
        children: children
    });
};

});

parcelRegister("9ZCby", function(module, exports) {

$parcel$export(module.exports, "NOTES_PANEL_ID", () => $da8db4b4b092aebd$export$6a60ddbd7f64aa47);
$parcel$export(module.exports, "NOTES_SIDEBAR_WIDTH", () => $da8db4b4b092aebd$export$a88ce0cc51c65c22);
const $da8db4b4b092aebd$export$6a60ddbd7f64aa47 = 'notes-sidebar';
const $da8db4b4b092aebd$export$a88ce0cc51c65c22 = 368; // same as HELP_PANEL_WIDTH

});

parcelRegister("57DNK", function(module, exports) {

$parcel$export(module.exports, "useNotesContext", () => $8ca502de13a031b3$export$47119eceeabe086c);
$parcel$export(module.exports, "NotesContextProvider", () => $8ca502de13a031b3$export$c4f58ceb5f6bc9c);

var $gwFzn = parcelRequire("gwFzn");

var $jln20 = parcelRequire("jln20");

var $9ZCby = parcelRequire("9ZCby");
const $8ca502de13a031b3$var$NotesContextDefaultValue = {
    openSidebar: ()=>{},
    closeSidebar: ()=>{},
    toggleSidebar: ()=>{}
};
const $8ca502de13a031b3$export$97bff92a36dbc61b = /*#__PURE__*/ (0, $gwFzn.createContext)($8ca502de13a031b3$var$NotesContextDefaultValue);
const $8ca502de13a031b3$export$47119eceeabe086c = ()=>(0, $gwFzn.useContext)($8ca502de13a031b3$export$97bff92a36dbc61b);
const $8ca502de13a031b3$export$c4f58ceb5f6bc9c = ({ children: children })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const openSidebar = (0, $gwFzn.useCallback)(()=>{
        rightSidebarContext.open((0, $9ZCby.NOTES_PANEL_ID), (0, $9ZCby.NOTES_SIDEBAR_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const closeSidebar = (0, $gwFzn.useCallback)(()=>{
        rightSidebarContext.closeAll();
    }, [
        rightSidebarContext
    ]);
    const toggleSidebar = (0, $gwFzn.useCallback)(()=>{
        if (rightSidebarContext.getCurrent()?.panelId === (0, $9ZCby.NOTES_PANEL_ID)) rightSidebarContext.closeAll();
        else rightSidebarContext.open((0, $9ZCby.NOTES_PANEL_ID), (0, $9ZCby.NOTES_SIDEBAR_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const notesContextValue = (0, $gwFzn.useMemo)(()=>({
            openSidebar: openSidebar,
            closeSidebar: closeSidebar,
            toggleSidebar: toggleSidebar
        }), [
        openSidebar,
        closeSidebar,
        toggleSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8ca502de13a031b3$export$97bff92a36dbc61b.Provider, {
        value: notesContextValue
    }, children);
};

});


//# sourceMappingURL=PageLayout.ff1a05a4.js.map
